import { Component, OnInit, OnDestroy, Output, EventEmitter  ,ChangeDetectorRef, NgZone ,ViewChild,TemplateRef} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { chartdata }  from '../class/chatdata';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import * as Highcharts from 'highcharts';
import { Options } from "highcharts";
import { ActivatedRoute,Router  } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Rtable } from '../class/rtabledata';
import Swal from 'sweetalert2';
import { DatePipe, formatDate  } from '@angular/common';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


type RangeKey = '100-5000' | '5001-30000' | '30001+';

type UserRow = {
    user_id: number;
    deposit_twd: number;
    get_text_num: number;
    id: number;
    name: string;
    uid: string;
    profile_pic: string;
};

type RangeGroup = {
    paging_key: any;
    page: number;        // 後端 0-based
    per_page: number;
    total: number;
    total_pages: number;
    paging: any;
    users: UserRow[];
};

type ApiData = Record<string, RangeGroup>;

type PageObj = {
  page: number;        // 前端 1-based
  per_page: number;
  total_count: number;
  total_pages: number;
}

type RangeBlock = {
    key: string;              // "100-5000" | "5001-30000" | "30001+"
    title: string;            // 後段班/中段班/前段班
    subtitle: string;         // 區間說明
    users: UserRow[];
    count: number;
    totalMsg: number;
    avgMsg: number;
    totalDeposit: number;
};

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
    providers: [DatePipe]
})
export class UserComponent implements OnInit, OnDestroy  {

    private boundResizeHandler = () => { this.checkDeviceType(); };

    ngOnDestroy(): void {
        window.removeEventListener('resize', this.boundResizeHandler);
    }
    @ViewChild('yourModalContent', { read: TemplateRef }) yourModalContent: TemplateRef<any>;
    @ViewChild('yourModalContent1', { read: TemplateRef }) yourModalContent1: TemplateRef<any>;
    @ViewChild('yourModalContent123', { read: TemplateRef }) yourModalContent123: TemplateRef<any>;
    @ViewChild('yourModalContenthistorymanage', { read: TemplateRef }) yourModalContenthistorymanage: TemplateRef<any>;
    @ViewChild('yourModalContentUserDetail', { read: TemplateRef }) yourModalContentUserDetail: TemplateRef<any>;
    @ViewChild('yourModalContentNicknameHistory', { read: TemplateRef }) yourModalContentNicknameHistory: TemplateRef<any>;
    showRegisterDate = false;

    isDesktop: boolean;
    @Output() notify = new EventEmitter<any>();
    depositFilter: 'all' | 'paid' | 'unpaid' = 'all';
    defaultAvatar = 'https://chatmate.tw/img/default.png';

    dataMap!: ApiData;

    pageobjMap: Record<string, PageObj> = {};   // 每個 range 各自一份 pageobj
    pageobjmsgstr: any;                             // 你原本用 deepcopy 的變數保留

    rangeOrder: RangeKey[] = ['30001+','5001-30000','100-5000'];

    rangeBlocks: RangeBlock[] = [];
    viewMode: 'cards' | 'table' = 'cards';
    keyword = '';

    contenthistory:any = [];
    contenthistoryData:any = [];
    nicknameHistoryData:any = [];
    gender:string = '0';
    now:string = '0';
    subnow:string = '0';
    sub_type:string = '0';
    tmp_img_b64:{};
    reward_num:number = 0;
    power:number = 0;
    search_gender:string = '-1';
    search_country:string = '-1';
    commType = 1;
    showPercentage:any = [false,false,false,false,false,false,false,false,false,false,false,false];
    menu_list:menulist = [
        {id:'0',name:'會員數據'},
        {id:'10',name:'Tag數據'},
        // {id:'6',name:'儲值方式比例圖'},
        {id:'1',name:'年紀性別對照圖'},
        {id:'2',name:'男女比例圖'},
        {id:'5',name:'平台比例圖'},
        {id:'7',name:'平台成長圖'},
        {id:'12',name:'活躍分析'},
        {id:'13',name:'懸賞與簡訊'},   // 全站懸賞紀錄（原本被註解掉的 11 懸賞列表併進來）+ 全站簡訊紀錄（系統群發／後台群發／後台單人 三來源）
        // {id:'11',name:'懸賞列表'},
        // {id:'3',name:'新增內部帳號'},
        // {id:'4',name:'修改帳號'}
    ]

    profile_menu_list:any = [
        {id:'0',name:'後台筆記'},
        {id:'1',name:'事件紀錄'},
        {id:'2',name:'交易紀錄'},
        {id:'3',name:'登入紀錄'},
        {id:'4',name:'貢獻名單'},
        {id:'5',name:'鑽石分析'},
        {id:'6',name:'新手任務'},
        {id:'7',name:'聊天列表'},
        {id:'8',name:'動態列表'},
        {id:'9',name:'金流紀錄'},
        {id:'10',name:'活動禮物'},
        {id:'11',name:'通訊紀錄'},
        {id:'13',name:'用戶標籤'},   // 後端 get_user_profile.php action 13（12 是實體禮物兌換，後台沒開）
        {id:'14',name:'懸賞紀錄'},   // bounty_list：他被懸賞 + 他去領別人的賞
        {id:'15',name:'簡訊紀錄'},   // once_sms_return(一次性) + sms_sent_log(群發) 合併
    ]
    // ── 用戶標籤（分群 A/B/C / 規則 / AI 聊天萃取；排程 voxy/cron/user_tag_cron.php 產生）──
    user_tags:any = null;             // shape_user_tags() 整理後的資料
    user_tags_uid:string = '';        // 目前載入的是哪個 uid，切下拉不重打
    user_tags_loading:boolean = false;
    user_tags_history_open:any = {};  // cat → 是否展開切換歷程
    tag_cat_order:string[] = ['分群','作息','花費','營收','個人頁','聊天萃取','穩聊對象','關係'];
    tag_cat_cls:any = {'分群':'seg','作息':'time','花費':'spend','營收':'income','個人頁':'profile','聊天萃取':'ai','穩聊對象':'pref','關係':'rel'};
    // 排程紀錄的 phase 代碼太內部，畫面上換成看得懂的字
    tag_phase_label:any = {rule:'規則標籤', pair:'聊天對象', partial:'本輪未完', final:'完成', skip:'略過', error:'錯誤'};
    // 舊資料的欄位名對照：2026-09-10 改了兩個名字，之前分析過的人存的還是舊名，
    // 這些標籤要等該用戶下次被分析才會換掉，先用對照表讓畫面立刻顯示正確名稱
    tag_key_label:any = {'收入/財力':'消費力', '愛聊對象數':'已分析對象'};
    gifttype_list:any = ['贈送','獲得'];
    type_list:any = ['','註冊紀錄','初次發布','動態解鎖','贊助紀錄','禮物贈送','贊助收入','禮物獲得','結算提領','儲值紀錄','活動成就'];
    type_chat_list:any = ['其他','文字','語音','圖片','影片','互動遊戲','小天使系統消息','動態留言','男觀看自動發圖','女群發','男觀看自動發文','禮物','聊天室私密照片'];
    type_commit_list:any = ['其他','語音','視訊','你畫我猜','輪盤','指令'];
    type_commit_err_list:any = ['api過慢做紀錄','通聯','2推播後的網路監測','3是前端異常上線時間計算'];
    Highcharts: typeof Highcharts = Highcharts;
    age_info:any=[];
    content_data:any=[];
    sort_obj:any = {column:'create_dt',sort:'0'}
    sort_obj_detail:any = {column:'login_times_front',sort:'0'}
    sort_obj_detail2:any = {column:'login_times_front',sort:'0'}
    validate_info:any={phone_num:'',validate:'',country_code:'886'};
    hot_list:any={list_str:'',score:0};
    country_list:any=[];
    emp_info:any=[];
    os_info:any=[];
    create_dt_info:any=[];
    create_dt_info2:any=[];
    create_dt_info3:any=[];
    create_dt_info4:any=[];
    deposit_info:any=[];
    user:any={};
    error_voice_list:any=[];
    fake_info:any = {id:-1,gender:'2',uid:'',pic:'',name:'',introduction:'',greeting:'歡迎找我聊天',birthday:'2003-01-01',hobby_name:''};
    updateFlag:boolean=false;
    lineOptions:Options = chartdata.line;
    lineOptions2:Options = {...chartdata.line1};
    lineOptions3:Options = {...chartdata.line1};
    lineOptions4:Options = {...chartdata.line2};
    lineOptions5:Options = {...chartdata.line2};
    barOptions:Options = chartdata.bar;
    pieOptions:Options = chartdata.pie;
    barOptions2:any = {...chartdata.muti_bar}
    barOptions3:any =  {...chartdata.muti_bar}
    barOptions4:any =  {...chartdata.muti_bar}
    barOptions5:any =  {...chartdata.muti_bar}
    pieOptions_data:Options = chartdata.pie;
    all_check:boolean;
    link:string = environment.link;
    web_net_info:string = environment.web_net_info;
    iconPic:string = environment.picfile+'icon-app.png';
    user_type:any = 1;
    search_date_user:any = '0';
    chart_satrt = 0;
    sql_name = '_allId';
    pagebolur:page = {page:0,count:10,total_count:0};
    pagebolurstr:string=JSON.parse(JSON.stringify(this.pagebolur))

    // 「懸賞與簡訊」分頁（menu 13）：rec_sub 切兩張表。懸賞沿用 bounty_list()/pagebolur；
    // 簡訊紀錄走 get_sms_record_list.php：一次性(once_sms_return)＋群發(sms_sent_log)＋手動(manual_sms_log) 三來源合併，
    // 帶來源／日期區間／關鍵字，並回一段區間內統計（stats）。
    rec_sub:string = 'sms';      // 預設簡訊紀錄（2026-09-16 老闆要求簡訊在左、預設）
    sms_log_arr:any[] = [];
    sms_log_keyword:string = '';
    sms_log_loading:boolean = false;
    sms_source:number = 0;       // 0 全部 / 1 一次性 / 2 群發 / 3 手動
    sms_start_dt:string = '';    // YYYY-MM-DD；進分頁時預設最近 30 天（群發表很大，不限日期會慢），按「不限日期」清空
    sms_end_dt:string = '';
    sms_stats:any = null;
    sms_view:string = 'rows';    // rows 逐筆紀錄 / camp 成效分析（依任務／批次／員工彙整，忽略關鍵字）
    sms_camp:any = null;         // camp 模式回傳 {once:[], bulk:[], bulk_trend:[], bulk_total:{}, manual_emp:[]}
    sms_camp_all:boolean = true; // 成效分析預設看全部歷史：群發批次才十幾個、每封的日期在 sms_sent_log 上，區間切了反而看不出趨勢
    sms_bulk_sort:any = {key:'sent', desc:true};   // 「系統群發」批次表的排序，前端排（資料量小）
    // 成效分析 UI（2026-09-16 重排）：三個子分頁；每張表前端分頁（資料都在手上，切頁不打 API）；圖表用 Highcharts，資料到了重建 options 物件即可
    sms_camp_tab:string = 'bulk';    // bulk 系統群發 / once 一次性 / manual 手動
    sms_pg:any = {bulk:{page:0,count:10,total_count:0}, trend:{page:0,count:12,total_count:0}, once:{page:0,count:10,total_count:0}, manual:{page:0,count:10,total_count:0}};
    sms_pg_str:any = {bulk:null, trend:null, once:null, manual:null};   // 給 app-pagnation 的複本（換新物件才會觸發它重算頁數）
    sms_chart:any = {trend:null, hour:null, batch:null, expo:null, once:null, manual:null};
    sms_points:any = null;       // 三竹簡訊點數餘額（admin_home_info.mitake）
    page_sms:page = {page:0,count:20,total_count:0};
    page_sms_str:any = JSON.parse(JSON.stringify(this.page_sms));

    //平台成長圖的頁簽
    pagegrow:page = {page:0,count:3,total_count:0};
    pagegrowstr:string=JSON.parse(JSON.stringify(this.pagegrow))

    packstatus:any = false;
    ticket_num:any = 0;
    serverExcelurl:string = '';
    user_date_list:any[] = [
        { "id": '0', "name": "請選擇區間篩選" },
        { "id": '1', "name": "無聊天行為" },
        { "id": '2', "name": "有聊天行為" },
        { "id": '3', "name": "無交易行為" },
        { "id": '4', "name": "有交易行為" },
    ]

    gender_list:any[] = [
        { "id": '-1', "name": "全部" },
        { "id": '1', "name": "男" },
        { "id": '2', "name": "女" },
    ]

    tag_list_type:any[] = [
        { "id": '-1', "name": "請選擇tag類別" },
        { "id": '1', "name": "時間類別" },
        { "id": '2', "name": "儲值類別" },
    ]

    groupTaglist:any[] = [
        { "id": '-1', "name": "上線時間" },
        { "id": '1', "name": "上線時間A" },
        { "id": '2', "name": "上線時間B" },
    ]

    // tag 選單只在第一次 get_user_list 撈，之後翻頁/排序/搜尋帶 skip_taglist 省後端重算
    taglistLoaded:boolean = false;

    order_option: any[] = [{ "id": 'id', "name": "註冊日期" },{ "id": 'gender', "name": "性別" },{ "id": 'followers', "name": "追蹤數" },{ "id": 'views', "name": "觀看次數" },{ "id": 'diamond', "name": "鑽石數" }, ];
    sort_option: any[] = [{ "id": 'desc', "name": "大到小" }, { "id": 'asc', "name": "小到大" }];

    status_option:any[] = [
        { "id": '-1', "name": "狀態不限" },
        { "id": '1', "name": "正常" },
        { "id": '0', "name": "停權" },
        { "id": '-2', "name": "未註冊完成" },
    ]
    track_option:any[] = [
        { "id": '0', "name": "追蹤狀態不限" },
        { "id": '1', "name": "追蹤無下文" },
        { "id": '2', "name": "追蹤有回歸" },
        { "id": '3', "name": "回歸有貢獻" },
    ]

    vender_option:any[] = [
        { "id": '0', "name": "全部用戶" },
        { "id": '2', "name": "經紀用戶" },
        { "id": '1', "name": "非經紀用戶" },
        { "id": '3', "name": "內部員工" },
    ]
    bountry_status:any[] = [
        { "id": '-2', "name": "全部懸賞狀態" },
        { "id": '-1', "name": "過期" },
        { "id": '0', "name": "取消" },
        { "id": '1', "name": "執行" },
        { "id": '2', "name": "待派彩" },
        { "id": '3', "name": "已派彩" },
    ]

    target_search:any = '';

    target_search_user:any = '';

    bountry_status_num:any = '-2';

    tool_obj:any={groupTag:[],tag:'-2',search_model:'',search_gender:'-1',vender:'0',search_country:'886',filter_status:'-1',is_enable:'1',filter_money_num:0,filter_num:0,sms_contnt:'',track:'0',profile_menu:'0'}

    changePhone = '';
    changeName = '';
    fakeAccountCount = 1;
    fakeAccountPassword = '';
    fakeAccountResult: string[] = [];

    groupTag = [];

    groupTagArr = [];

    origroupTag = [];

    uptime = '';

    bounty_menu = [];

    err_data = [];
    yearList = [];

    datestatus = false;

    constructor(
        public httpClient: HttpClient,
        private  route: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone,
        private modalService: NgbModal,

    ){}
    posts_attributes:any=[];
    posts_input:any=[];
    items = [];

    areaOptions: Options = JSON.parse(JSON.stringify(chartdata.area_bar));
    areaOptions2: Options = JSON.parse(JSON.stringify(chartdata.area_bar));
    areaOptions3: Options = JSON.parse(JSON.stringify(chartdata.area_bar));
    areaOptions4: Options = JSON.parse(JSON.stringify(chartdata.area_bar));

    overlayFlag:boolean=false;

    detail_data:any=[];
    chat_obj = {me:'-1',mename:'',mepic:'',to:'-1',toname:'',topic:''};
    packet:number=0;
    chat_page:number=1;
    chat_page_size:number=30;
    chat_total_count:number=0;
    chat_total_pages:number=0;
    chat_loading:boolean=false;
    chat_page_input:any='';
    is_read:any=['未讀','已讀'];
    flag:any={};
    chartlistdata:any={};
    moneyout:any=['','一般出金','經紀出金','代理出金'];
    moneyin:any=['','IAP','外部轉帳儲值','綠界','藍新'];
    os_typelist:any=['','安卓','ios','web','其他'];
    time:any={'start':'','end':''};
    errtime:any={'start':'','end':''};
    showDatePicker: boolean = false;
    Usertime:any={'start':'','end':''};
    LastUsertime:any={'start':'','end':''};

    timeset = [{ type:1 , name: "過去7天", num: -7 }, { type:1 , name: "昨天", num: -1 },{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];
    dimomenttimeset = [{ type:2 , name: "過去一個月", num: -1 },{ type:2 , name: "上上個月", num: -2 },{ type:4 , name: "近二個月", num: -2 },{ type:4 , name: "近三個月", num: -3 },{ type:4 , name: "近四個月", num: -4 },{ type:4 , name: "近五個月", num: -5 },{ type:4 , name: "近六個月", num: -6 }];
    // 近半年／近一年 超過 62 天 → Tag數據自動改「趨勢模式」走 get_tag_trend.php（見 tag_trend_mode）
    Usertimeset = [{ type:1 , name: "過去7天", num: -7 }, { type:1 , name: "昨天", num: -1 },{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }, { type:4 , name: "近半年（趨勢）", num: -6 }, { type:4 , name: "近一年（趨勢）", num: -12 }];

    // Tag數據 長期趨勢（2026-09-16）：區間超過 tag_trend_days_limit 天改走 get_tag_trend.php，只讀排程每天寫好的人數，不撈名單。
    // 原本 get_user_list 會把區間內每一天的名單整包解開做交集（幽靈用戶一天 34 萬人），7 天就要 6 秒，一年會把伺服器吃爆。
    tag_trend_mode:boolean = false;      // true＝區間超過上限，只有圖沒有名單
    tag_trend_days_limit:number = 62;
    tag_trend:any = null;                // get_tag_trend.php 原始回傳
    tagTrendOptions:any = null;
    tag_trend_loading:boolean = false;
    tag_trend_notes:string[] = [];       // 圖下方的白話說明：整段沒資料是為什麼（tag 建立日之前／補算還沒跑／排程還沒算）
    tag_combine:boolean = true;          // 多選 tag：true＝同時符合（交集，一條線）；false＝各自一條線
    tag_y_zero:boolean = false;          // Y 軸從 0 起（預設關：幾十萬人的 tag 一天只差幾十人，從 0 畫會變一條直線看不出變化）
    tag_trend_seq:number = 0;            // 請求序號：使用者換條件後，舊的回應／輪詢丟掉
    tag_trend_polling:boolean = false;   // 交集還在後端分批算（combo.pending > 0），每 0.4 秒再叫一次
    tag_gran:string = 'week';            // day / week / month；週、月取該期間「最後一個有資料的日子」（人數是存量，取期末）
    tag_yaxis:string = 'count';          // count 人數 / pct 占全站 %（÷ 當天全站累計註冊人數）
    tag_view_auto:boolean = true;        // 使用者沒手動切過粒度／Y 軸之前，每次查詢依天數與 tag 數給預設；切過就尊重他的選擇
    tag_show_active:boolean = false;     // 同時畫有效人數（排除停權／未完成註冊／已刪帳號；只有排程新寫的日子有）
    tag_month_rows:any[] = [];           // 圖下方月表，和「月」桶同一套算法
    LastTimeUsertimeset = [{ type:1 , name: "過去7天", num: -7 }, { type:1 , name: "昨天", num: -1 },{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];

    diamondtotal = 0;
    showDatePickersTatus = true;
    showDatePickersTatusx = true;
    lastshowDatePickersTatusx = true;
    generarr = ['-','男生','女生'];
    temp_err:any = [];
    tcontent = [
        {title:'名字',content:'name',type:2},
        {title:'大頭貼',content:'profile_pic',type:1},
        {title:'性別',content:'gender',replaceArr:this.generarr},
        {title:'出入金',content:'money',type:3,css:'min-width: 80px;',sort:'money'},
        {title:'現有鑽石數',content:'diamond',type:3,css:'min-width: 80px;',sort:'diamond'},
        {title:'總收支',content:'total_income',type:3,css:'min-width: 130px;'},
        {title:'文字收支',content:'text_income',type:3,css:'min-width: 130px;'},
        {title:'語音收支',content:'voice_income',type:3,css:'min-width: 130px;'},
        {title:'視訊收支',content:'video_income',type:3,css:'min-width: 130px;'},
        {title:'相簿收支',content:'album_income',type:3,css:'min-width: 130px;'},
        // {title:'遊戲收益',content:'game_income',type:3,css:'min-width: 130px;'},
        {title:'活動獎勵',content:'active_reward',type:3,css:'min-width: 130px;'},
        {title:'禮物收支',content:'gift_reward',type:3,css:'min-width: 130px;'},
        // {title:'直播收益',content:'live_reward',type:3,css:'min-width: 130px;'},
        // {title:'約會收益',content:'date_reward',type:3,css:'min-width: 130px;'},
        // {title:'語音房收益',content:'voice_room_income',type:3,css:'min-width: 130px;'},
        {title:'聊天室紅包收支',content:'donate_income',type:3,css:'min-width: 150px;'},
        {title:'其他收支',content:'other',type:3,css:'min-width: 130px;'},
        {title:'註冊',content:'create_dt',css:'min-width: 80px;',sort:'create_dt'},
        {title:'最後登入',content:'last_singin_date',type:3,css:'min-width: 80px;',sort:'last_singin_date'},
        {title:'狀態',content:'is_enable',type:3},
        {title:'操作',content:'gg',type:3},
        {title:'memo',content:'memo',type:3},
    ];

    contenthistorytcontent = [
        {title:'經紀名稱',content:'vendor_name'},
        {title:'開始時間',content:'start_date'},
        {title:'結束時間',content:'end_date'},
    ];

    nicknameHistorytcontent = [
        {title:'數量',content:'index'},
        {title:'暱稱',content:'user_name'},
        {title:'修改時間',content:'update_dt'},
    ];

    list_tcontent = [
        {title:'用戶排名',content:'rank'},
        {title:'用戶',content:'name',type:2},
        {title:'在線分鐘數',content:'login_times_front',sort:'login_times_front',css:'min-width: 150px;'},
        {title:'動態數',content:'story_num',sort:'story_num',css:'min-width: 150px;'},
        {title:'發出訊息數',content:'text_num',sort:'text_num',css:'min-width: 150px;'},
        {title:'接收訊息數',content:'get_text_num',sort:'get_text_num',css:'min-width: 150px;'},
        {title:'語音',content:'voice_time',sort:'voice_time',css:'min-width: 150px;'},
        {title:'視訊',content:'video_time',sort:'video_time',css:'min-width: 150px;'},
        {title:'操作',content:'gg',type:3},
    ];

    list_arr = [];

    list_detail_tcontent = [
        {title:'日期',content:'date',sort:'date'},
        {title:'用戶',content:'name',type:2},
        {title:'在線分鐘數',content:'login_times_front',sort:'login_times_front'},
        {title:'動態數',content:'story_num',sort:'story_num'},
        {title:'發出訊息數',content:'text_num',sort:'text_num'},
        {title:'接收訊息數',content:'get_text_num',sort:'get_text_num'},
        {title:'語音',content:'voice_time',sort:'voice_time'},
        {title:'視訊',content:'video_time',sort:'video_time'},
    ];

    list_detail_arr = [];


    bluer_tcontent = [];

    story_type_num = 0;
    view_story_type_num = 0;
    story_lock_num = 1;
    copy_story_num = 0;
    copy_story_type =[
        {id:0,name:'全部動態'},
        {id:1,name:'盜圖動態'}
    ];

    story_type =[
        {id:0,name:'我的動態'},
        {id:1,name:'我的解鎖動態'}
    ];

    view_story_type = [
        { id: 0, name: '顯示於用戶解鎖動態' },
        { id: 1, name: '不顯示於用戶解鎖動態' }
    ];

    story_lock_type =[
        {id:1,name:'聊天室解鎖動態'},
        {id:3,name:'非聊天室解鎖動態'}
    ];

    urltoken:string = '';
    urltokencsv:string = '';
    urlprotoken:string = '';
    urltabletoken:string = '';

    preurl:string = '';

    oriNum = 0;

    top_data = [];
    all_data = [];

    bounty_menuLeng = 0;
    bounty_time :any={};
    bounty_timeset = [{ type:1 , name: "今天", num: -0 }];
    bounty_arr:any = [];
    limitset = [{ type:1,min:0,max:180 }]; //[{ type:1,min:7,max:10 }]

    //全部執行中的懸賞id
    bounty_id:any = [];

    abounty_Data = [];

    err_detail = [];

    diamond_second = 0;

    target_by_err:any = [];
    status_by_err:any = 0;
    err_search_model:any = [];
    err_target:any = [];
    err_relationship = '';
    errtype = 1;

    withdrawSuccess: { [userId: number]: boolean } = {}; // 存放每個用戶的提領狀態


////////活躍分析///////////////////
    selectedGender = 'male';
    selectedPlatform = '0';
    selectedVendor = '0';
    selectedLevel = '0';
    selectedFilterPlatform = '0';

 // 日期相關
    startDate = ''; // 用於每日
    endDate = '';
    startDatecreate
    endDatecreate
    startMonthcreate = '';
    endMonthcreate = '';
    today = new Date().toISOString().split('T')[0];

  // 月份相關
    startMonth = ''; // 用於每月,格式: "2024-10"
    endMonth = '';
    currentMonth = new Date().toISOString().slice(0, 7); // 格式: "2024-10"
    detail_user = 0;
    timeGranularity = 'daily';
    selectedList = 'pic';
    vendorList = []; // 從 vendor_list 取得
    levelList = []; // 從 monthly_mission_record GROUP BY mt_level 取得
    stats = {
        activeUsers: 0,
        totalOnlineTime: 0,
        avgDailyOnline: 0,
        totalMessages: 0
    };

    metrics = [
        { label: '在線秒數', value: 'online_seconds' },
        { label: '發出訊息數', value: 'sent_messages' },
        { label: '接收訊息數', value: 'received_messages' },
        { label: '語音次數', value: 'voice_count' },
        { label: '視訊次數', value: 'video_count' },
        { label: '動態數', value: 'post_count' }
    ];

    tableData = []; // 從 daily_activity / daily_activity_male 取得
    activeTab = 'query';
    activeTypeTab = 'message';

    // 區間差異分析 - 第一組日期
    startDate1: string;
    endDate1: string;
    startMonth1: string;
    endMonth1: string;


    // 區間差異分析 - 第二組日期
    startDate2: string;
    endDate2: string;
    startMonth2: string;
    endMonth2: string;

    summary = {
        period1_total: 0,
        period2_total: 0,
        new_users_count: 0,
        lost_users_count: 0,
        common_users_count: 0,
        growth_rate: 0
    };

    new_users: any[] = [];
    lost_users: any[] = [];
    diff_data = [];

    sortKey: 'deposit_twd' | 'get_text_num' = 'get_text_num';
    sortDir: 'asc' | 'desc' = 'desc';
    hideZeroMsg = false;

    analysisData: any = {};

    searchHas = '';
    searchNo = '';

    // 排序狀態
    hasSort: 'msg_desc' | 'msg_asc' | 'name_asc' | 'name_desc' = 'msg_desc';
    noSort: 'name_asc' | 'name_desc' | 'uid_asc' | 'uid_desc' | 'id_desc' | 'id_asc' = 'id_desc';

    hasSort2: 'msg_desc' | 'msg_asc' | 'delta_desc' | 'delta_asc' | 'name_asc' | 'name_desc' | 'uid_asc' | 'uid_desc' | 'id_asc' | 'id_desc' = 'msg_desc';
    noSort2: 'name_asc' | 'name_desc' | 'uid_asc' | 'uid_desc' | 'id_asc' | 'id_desc' = 'id_desc';

    pagemessage:page = {page:0,count:10,total_count:0};
    pagemessagestr:string=JSON.parse(JSON.stringify(this.pagemessage))
    pagemessage1:page = {page:0,count:10,total_count:0};
    pagemessagestr1:string=JSON.parse(JSON.stringify(this.pagemessage1))
    pagemessage2:page = {page:0,count:10,total_count:0};
    pagemessagestr2:string=JSON.parse(JSON.stringify(this.pagemessage2))

    pagegirl_message1:page = {page:0,count:10,total_count:0};
    pagegirl_messagestr1:string=JSON.parse(JSON.stringify(this.pagegirl_message1))
    pagegirl_message2:page = {page:0,count:10,total_count:0};
    pagegirl_messagestr2:string=JSON.parse(JSON.stringify(this.pagegirl_message2))

    oneYearAgo!: string;
    oneYearAgoMonth!: string;

    onTimesearch(){
        this.default_page();
        this.get_user_active_chart();

    }


    getRangeTip(key: string): string {
        switch (key) {
            case '100-5000':
                return '後段班（低儲值用戶）';
            case '5001-30000':
                return '中段班（中等儲值用戶）';
            case '30001+':
                return '前段班（高儲值用戶）';
            case '0-99':
                return '未儲值用戶';
            default:
                return '';
        }
    }


    hasSortChange(){
        this.sortDir = this.hasSort == 'msg_desc' ? 'desc' : 'asc';
        this.get_user_active_chart();
    }

    rangeLabel(rangeKey: string): string {
        const map: Record<string, string> = {
          '0-99': '未儲值',
          '100-5000': '後段班',
          '5001-30000': '中段班',
          '30001+': '前段班',
        };
        return map[rangeKey] ?? rangeKey;
    }

    private safeArr(v: any): any[] {
        return Array.isArray(v) ? v : [];
    }

    cmpStr2(a: any, b: any): number {
        return String(a ?? '').localeCompare(String(b ?? ''), 'zh-Hant', { numeric: true, sensitivity: 'base' });
    }

    private matchSearch(u: any, keyword: string): boolean {
        const k = (keyword || '').trim().toLowerCase();
        if (!k) return true;

        const name = String(u?.name ?? '').toLowerCase();
        const uid  = String(u?.uid ?? '').toLowerCase();
        const id   = String(u?.id ?? u?.user_id ?? '').toLowerCase();

        return name.includes(k) || uid.includes(k) || id.includes(k);
    }

    // ===== 兩個清單（仍然分 has/no）=====
    get hasList(): any[] {
      // hasText: improved + still + worse 先合併（你目前只有 still）
      const improved = this.safeArr(this.analysisData?.hasText?.improved);
      const still    = this.safeArr(this.analysisData?.hasText?.still);
      const worse    = this.safeArr(this.analysisData?.hasText?.worse);
      return [...improved, ...still, ...worse];
    }

    get noList(): any[] {
      const still = this.safeArr(this.analysisData?.noText?.still);
      const _new  = this.safeArr(this.analysisData?.noText?.new);
      return [...still, ..._new];
    }

    // ===== 有傳：搜尋 + 排序 =====
    get hasView(): any[] {
      const filtered = this.hasList.filter(u => this.matchSearch(u, this.searchHas));
      const arr = [...filtered];

      switch (this.hasSort2) {
        case 'msg_desc':
          return arr.sort((a, b) => Number(b.after_text_num ?? b.text_num ?? 0) - Number(a.after_text_num ?? a.text_num ?? 0));
        case 'msg_asc':
          return arr.sort((a, b) => Number(a.after_text_num ?? a.text_num ?? 0) - Number(b.after_text_num ?? b.text_num ?? 0));
        case 'delta_desc':
          return arr.sort((a, b) => Number(b.delta_text_num ?? 0) - Number(a.delta_text_num ?? 0));
        case 'delta_asc':
          return arr.sort((a, b) => Number(a.delta_text_num ?? 0) - Number(b.delta_text_num ?? 0));
        case 'name_asc':
          return arr.sort((a, b) => this.cmpStr2(a.name, b.name));
        case 'name_desc':
          return arr.sort((a, b) => this.cmpStr2(b.name, a.name));
        case 'uid_asc':
          return arr.sort((a, b) => this.cmpStr2(a.uid, b.uid));
        case 'uid_desc':
          return arr.sort((a, b) => this.cmpStr2(b.uid, a.uid));
        case 'id_asc':
          return arr.sort((a, b) => Number(a.id ?? a.user_id ?? 0) - Number(b.id ?? b.user_id ?? 0));
        case 'id_desc':
          return arr.sort((a, b) => Number(b.id ?? b.user_id ?? 0) - Number(a.id ?? a.user_id ?? 0));
        default:
          return arr;
      }
    }

    // ===== 沒傳：搜尋 + 排序 =====
    get noView(): any[] {
      const filtered = this.noList.filter(u => this.matchSearch(u, this.searchNo));
      const arr = [...filtered];

      switch (this.noSort2) {
        case 'name_asc':
          return arr.sort((a, b) => this.cmpStr2(a.name, b.name));
        case 'name_desc':
          return arr.sort((a, b) => this.cmpStr2(b.name, a.name));
        case 'uid_asc':
          return arr.sort((a, b) => this.cmpStr2(a.uid, b.uid));
        case 'uid_desc':
          return arr.sort((a, b) => this.cmpStr2(b.uid, a.uid));
        case 'id_asc':
          return arr.sort((a, b) => Number(a.id ?? a.user_id ?? 0) - Number(b.id ?? b.user_id ?? 0));
        case 'id_desc':
          return arr.sort((a, b) => Number(b.id ?? b.user_id ?? 0) - Number(a.id ?? a.user_id ?? 0));
        default:
          return arr;
      }
    }

    getDelta(u: any): number {
      const v = u?.delta_text_num;
      return v === undefined || v === null ? 0 : Number(v);
    }

    isDeltaGood(u: any): boolean {
      return this.getDelta(u) > 0;
    }

    isDeltaBad(u: any): boolean {
      return this.getDelta(u) < 0;
    }

    isDeltaNeutral(u: any): boolean {
      return this.getDelta(u) === 0;
    }

    get totalTextNum(): number {
        const list = Array.isArray(this.dataMap?.hasText) ? this.dataMap!.hasText : [];
        return list.reduce((sum: number, u: any) => sum + Number(u?.text_num || 0), 0);
    }

    get interactionRate(): number {
        const has = Number(this.dataMap?.hasText_total ?? 0);
        const no  = Number(this.dataMap?.noText_total ?? 0);

        const total = has + no;

        return total > 0
            ? Math.round((has / total) * 100)
        : 0;
    }

    // 幫你做一個穩的字串比較（中文英文都不會爆）
    private cmpStr(a: any, b: any): number {
        const aa = String(a ?? '').trim();
        const bb = String(b ?? '').trim();
        return aa.localeCompare(bb, 'zh-Hant', { numeric: true, sensitivity: 'base' });
    }

    get hasSorted(): any[] {
      const list = Array.isArray(this.dataMap?.hasText) ? this.dataMap!.hasText : [];
      const arr = [...list];

      switch (this.hasSort) {
        case 'msg_desc':
          return arr.sort((a, b) => Number(b.text_num || 0) - Number(a.text_num || 0));
        case 'msg_asc':
          return arr.sort((a, b) => Number(a.text_num || 0) - Number(b.text_num || 0));
        case 'name_asc':
          return arr.sort((a, b) => this.cmpStr(a.name, b.name));
        case 'name_desc':
          return arr.sort((a, b) => this.cmpStr(b.name, a.name));
        default:
          return arr;
      }
    }

    get noSorted(): any[] {
        const list = Array.isArray(this.dataMap?.noText) ? this.dataMap!.noText : [];
        const arr = [...list];

        switch (this.noSort) {
            case 'name_asc':
                return arr.sort((a, b) => this.cmpStr(a.name, b.name));
            case 'name_desc':
                return arr.sort((a, b) => this.cmpStr(b.name, a.name));
            case 'uid_asc':
                return arr.sort((a, b) => this.cmpStr(a.uid, b.uid));
            case 'uid_desc':
                return arr.sort((a, b) => this.cmpStr(b.uid, a.uid));
            case 'id_desc':
                return arr.sort((a, b) => Number(b.id || 0) - Number(a.id || 0));
            case 'id_asc':
                return arr.sort((a, b) => Number(a.id || 0) - Number(a.id || 0));
            default:
                return arr;
        }
    }

    private rangeMeta: Record<string, { title: string; subtitle: string }> = {
        '100-5000': { title: '後段班', subtitle: '100～5,000' },
        '5001-30000': { title: '中段班', subtitle: '5,001～30,000' },
        '30001+': { title: '前段班', subtitle: '30,001+' },
    };





    toggleSortDir() {
        this.sortDir = this.sortDir === 'desc' ? 'asc' : 'desc';
        this.default_page();
        this.get_user_active_chart();
    }

    get filteredBlocks() {
        const data = this.dataMap ?? {};
        const kw = (this.keyword ?? '').trim().toLowerCase();

        const key = this.sortKey as 'deposit_twd' | 'get_text_num';
        const isDesc = this.sortDir === 'desc';

        const sortUsers = (users: any[]) => {
            return [...users].sort((a, b) => {
                const av = Number(a?.[key] ?? 0);
                const bv = Number(b?.[key] ?? 0);

                if (av === bv) return 0;
                return isDesc ? (bv - av) : (av - bv); // ✅ 乾淨且不會搞反
            });
        };

        // 你想要的區間排序（前段->中段->後段）
        const order = ['0-99','30001+', '5001-30000', '100-5000'];

        return order
            .filter(rangeKey => !!data[rangeKey])
            .map(rangeKey => {
                const group = data[rangeKey];
                let users = group?.users ?? [];

            // 隱藏 0 訊息
            if (this.hideZeroMsg) {
                users = users.filter(u => Number(u?.get_text_num ?? 0) > 0);
            }

            // 排序（只排序當頁 users）
            users = sortUsers(users);

            const count = data[rangeKey].paging.total_count; // ✅ 使用後端 total
            const totalMsg = (group?.users ?? []).reduce((s, u) => s + Number(u?.get_text_num ?? 0), 0);
            const avgMsg = count ? Math.round((totalMsg / count) * 10) / 10 : 0;
            const paging_key = data[rangeKey].paging_key;
            return {
                key: rangeKey,
                title:  rangeKey === '0-99'? '未儲值': rangeKey === '30001+'? '前段班': rangeKey === '5001-30000'? '中段班': '後段班',
                users,
                // ✅ 分頁資訊（A方式）
                paging_key: paging_key,

                // ✅ 卡片可用的統計（如果你想顯示）
                count,
                totalMsg,
                avgMsg,
            };
        });
    }

    getPageList(current: number, total: number): number[] {
        // 顯示最多 5 個頁碼：例如 1 2 3 4 5 / 3 4 5 6 7
        const max = 5;
        if (total <= max) return Array.from({ length: total }, (_, i) => i + 1);

        let start = Math.max(1, current - 2);
        let end = start + max - 1;

        if (end > total) {
          end = total;
          start = end - max + 1;
        }

        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }

    selectActiveTab(selectedTab: string){
        this.defalt_create();
        this.default_page();
        this.activeTypeTab = selectedTab;
        this.get_user_active_chart();
    }

    selectTab(selectedTab: string){
        this.target_search_user = '';
        this.defalt_create();
        this.default_page();
        this.activeTab = selectedTab;
        this.get_user_active_chart();
    }

    onGenderChange(gender: string) {
        this.default_page();
        this.selectedGender = gender;
        this.get_user_active_chart();

    }

    // 清除搜尋
    clearSearch() {
        this.target_search_user = '';
        this.get_user_active_chart();

        // 可選：清除後重新載入原始資料
        // this.loadInitialData();
    }

    defalt_create(){
        this.showRegisterDate = false;
    }

    default_page(){
        this.list_arr = [];
        this.list_detail_arr = [];
        this.pageobj.total_count = 0;
        this.pageobj = {page:0,count:10,total_count:0};
        this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));
        this.pageobj6.total_count = 0;
        this.pageobj6 = {page:0,count:10,total_count:0};
        this.pageobjstr6=JSON.parse(JSON.stringify(this.pageobj6));
        this.pagemessage = {page:0,count:10,total_count:0};
        this.pagemessagestr=JSON.parse(JSON.stringify(this.pagemessage));
        this.pagemessage1 = {page:0,count:10,total_count:0};
        this.pagemessagestr1=JSON.parse(JSON.stringify(this.pagemessage1));
        this.pagemessage2 = {page:0,count:10,total_count:0};
        this.pagemessagestr2=JSON.parse(JSON.stringify(this.pagemessage2));
        this.pagegirl_message1 = {page:0,count:10,total_count:0};
        this.pagegirl_messagestr1=JSON.parse(JSON.stringify(this.pagegirl_message1));
        this.pagegirl_message2 = {page:0,count:10,total_count:0};
        this.pagegirl_messagestr2=JSON.parse(JSON.stringify(this.pagegirl_message2));
    }

    onListChange(List: string) {
        this.default_page();
        this.selectedList = List;
        this.get_user_active_chart();

    }

    onFilterChange(act = 0) {

        //單區間月份帶入區間比對
        if(act == 1){
            this.startMonth1 = this.startMonth;
            this.endMonth1 = this.endMonth;
            this.startMonth2 = this.startMonth;
            this.endMonth2 = this.endMonth;
        }

        this.default_page();
        this.get_user_active_chart();
    }

    onFilterListChange() {
        this.default_page();
        this.get_user_active_chart();
    }

    onMetricChange(metric: string) { }

    callitem(item){

        console.log('itemmss',item)

        this.target_by_err = item;

        if(this.target_by_err.gender == '2'){
            this.error_voice_list.voice_fee = this.target_by_err.voice_fee;
            this.error_voice_list.video_fee = this.target_by_err.video_fee;
        }

        if(this.target_by_err.is_enable == 0){
            this.status_by_err = -1; //停權
        }

        if(this.target_by_err.phone_num < 0){
            this.status_by_err = -2; //刪帳號
        }

    }

    searchstr(item){
        this.err_search_model = item;
        this.err_target.user_id = '';
        this.err_target.uid = '';
        this.err_relationship = '';
    }

    add_err(){

        this.loading = true;
        //type = 2 更新
        const body = {
            errtime:this.errtime,type:1,error_voice_list:this.error_voice_list,target_by_err:this.target_by_err,errtype:this.errtype
        };

        this.httpClient.post<any>("/v1/common/send_diamons.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                Swal.fire("異常通訊紀錄已新增!", "", "success");
                this.comm_type(2)
            }
        });
    }


    send_diamon(second,dataitem,index){

        const list_id = this.temp_err.id;

        if(second == 0){
            second = dataitem.duration;
        }

        this.loading = true;

        //type = 2 更新
        const body = {
            second:second,dataitem:dataitem,type:0,list_id:list_id,index:index
        };


        this.httpClient.post<any>("/v1/common/send_diamons.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                Swal.fire("完成鑽石補送申請!", "", "success");
                this.get_err_comm(this.temp_err);
            }
        });


    }

    view_user_history(user_id,action){
        this.detail_user = user_id;
        if(action != 1){
            this.modalService.open(this.yourModalContentUserDetail, { centered: true,size: 'lg' });
        }
        const body = {
            sort_obj:this.sort_obj_detail2,
            page: this.pageobj6.page,
            count:this.pageobj6.count,
            selectedList:this.selectedList,
            selectedFilterPlatform:this.selectedFilterPlatform,
            selectedVendor:this.selectedVendor,
            selectedLevel:this.selectedLevel,gender:this.selectedGender,
            os_type:this.selectedPlatform,
            timeGranularity:this.timeGranularity,
            startDate:this.startDate,
            endDate:this.endDate,
            startMonth:this.startMonth,
            endMonth:this.endMonth,
            user_id:user_id,
            history:1
        };


        this.httpClient.post<any>("/v1/common/get_user_active_chart.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.list_detail_arr = res.data;
                this.pageobj6.total_count = res.total;
                this.pageobjstr6=JSON.parse(JSON.stringify(this.pageobj6));
                this.cdr.detectChanges();

            }
        });


    }

    view_history(){
        this.modalService.open(this.yourModalContenthistorymanage, { centered: true, size: 'md' });
        this.contenthistory = this.edit_data;

        console.log('contenthistory',this.contenthistory);

        const body = {
            page: this.pageobj5.page,
            count:this.pageobj5.count,
            uid:this.contenthistory.uid,
            history:1
        };

        this.httpClient.post<any>("/v1/common/get_user_profile.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.contenthistoryData = res.data;
            }
        });
    }

    view_nickname_history(){
        this.modalService.open(this.yourModalContentNicknameHistory, { centered: true, size: 'md' });
        this.loadNicknameHistory();
    }

    loadNicknameHistory(){
        console.log(this.edit_data);
        const body = {
            token: Dep.token,
            userID: this.edit_data.id,
            page: this.pageobj7.page,
            count: this.pageobj7.count
        };

        this.httpClient.post<any>("/v1/common/get_user_name_log.php", body).subscribe(res => {
            this.loading = false;
            if(res.status){
                // 為每條記錄添加序號
                this.nicknameHistoryData = res.data.map((item, index) => ({
                    ...item,
                    index: (this.pageobj7.page * this.pageobj7.count) + index + 1
                }));
                // 修正：API 返回的是 totalCount，不是 total_count
                this.pageobj7.total_count = res.totalCount || 0;
                this.pageobjstr7 = JSON.parse(JSON.stringify(this.pageobj7));
                console.log('分頁資訊:', this.pageobj7);
            }
        });
    }

    adderrlist(edit_data){
        this.modalService.open(this.yourModalContent123, { centered: true,size: 'lg' });
        this.error_voice_list = edit_data;
    }


    // 在你的 Angular 组件中添加以下方法
    validateInput() {
        if (this.diamond_second < 0) {
            this.diamond_second = 0; // 如果小于0则重设为0
        }
    }

    insert_diamond(dataitem){
        console.log('dataitem',dataitem)
    }

    comm_type(type){
        this.commType = type;
        this.get_profile(this.edit_data);
    }

    savebounty(id){

        this.loading = true;

        //type = 2 更新
        const body = {
            type:2,data:id,diamond:this.edit_bounty_data.diamond,bounty_time:this.bounty_time
        };


        this.httpClient.post<any>("/v1/common/bounty_controller.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                Swal.fire("懸賞用戶更新完成!", "", "success");
                this.init_list();
            }
        });




    }

    bounty_list(){

        this.bounty_id = [];

        const body = {type:0,bountryststus:this.bountry_status_num,page: this.pagebolur.page,count:this.pagebolur.count};

        this.httpClient.post<any>("/v1/common/bounty_controller.php",body).subscribe(res => {

            if(res.status){

                this.pagebolur.total_count = res.bounty_count;
                this.pagebolurstr = JSON.parse(JSON.stringify(this.pagebolur))

                this.bounty_arr = res.bounty_data;
                this.bounty_arr.forEach(v => {
                    this.bounty_id.push(v.user_id);
                });

            }
        });

    }

    // 「懸賞與簡訊」分頁的簡訊紀錄（全站三來源）
    sms_record_list(){
        this.sms_log_loading = true;
        // 成效分析勾「全部歷史」時不送日期（後端空＝不限）；逐筆紀錄照日期，掃整張群發表會慢
        const all_history = (this.sms_view == 'camp' && this.sms_camp_all);
        const body = {
            page: this.page_sms.page, count: this.page_sms.count,
            // 成效分析用子分頁切三個來源，一律撈全部（source 0），不吃逐筆那排的來源下拉
            keyword: this.sms_log_keyword, source: this.sms_view == 'camp' ? 0 : this.sms_source,
            start_dt: all_history ? '' : this.sms_start_dt, end_dt: all_history ? '' : this.sms_end_dt,
            mode: this.sms_view,
        };
        this.httpClient.post<any>("/v1/common/get_sms_record_list.php", body).subscribe(res => {
            this.sms_log_loading = false;
            if(res.status){
                this.sms_points = (res.sms_points === undefined) ? null : res.sms_points;
                if(this.sms_view == 'camp'){
                    this.sms_camp = res.camp || {once:[], bulk:[], bulk_trend:[], bulk_total:null, manual_emp:[]};
                    if(!Array.isArray(this.sms_camp.bulk)) this.sms_camp.bulk = [];
                    if(!Array.isArray(this.sms_camp.bulk_trend)) this.sms_camp.bulk_trend = [];
                    if(!Array.isArray(this.sms_camp.bulk_hour)) this.sms_camp.bulk_hour = [];
                    if(!Array.isArray(this.sms_camp.once)) this.sms_camp.once = [];
                    if(!Array.isArray(this.sms_camp.manual_emp)) this.sms_camp.manual_emp = [];
                    this.sms_apply_bulk_sort();
                    this.sms_pg_reset();
                    this.sms_build_charts();
                }else{
                    this.sms_log_arr = res.data || [];
                    this.sms_stats = res.stats || null;
                    this.page_sms.total_count = res.total_count || 0;
                    this.page_sms_str = JSON.parse(JSON.stringify(this.page_sms));
                }
            }else{
                this.sms_log_arr = [];
                this.sms_stats = null;
                this.sms_camp = null;
            }
        }, () => { this.sms_log_loading = false; });
    }

    sms_set_view(v:string){
        if(this.sms_view == v) return;
        this.sms_view = v;
        this.page_sms.page = 0;
        this.sms_record_list();
    }

    // 「系統群發」批次表：點欄位標題排序，同一欄再點一次反向；數字欄用數字比、其他字串比，同值依批次 id 新到舊
    sms_sort_bulk(key:string){
        if(this.sms_bulk_sort.key == key){
            this.sms_bulk_sort.desc = !this.sms_bulk_sort.desc;
        }else{
            this.sms_bulk_sort = {key:key, desc:true};
        }
        this.sms_apply_bulk_sort();
        // 重排後回第一頁，不然停在第 2 頁看到的不是排序後的前幾筆
        this.sms_pg.bulk = {...this.sms_pg.bulk, page:0};
        this.sms_pg_str.bulk = {...this.sms_pg.bulk};
    }

    sms_apply_bulk_sort(){
        if(!this.sms_camp || !Array.isArray(this.sms_camp.bulk)) return;
        const k = this.sms_bulk_sort.key;
        const d = this.sms_bulk_sort.desc ? -1 : 1;
        this.sms_camp.bulk.sort((a:any, b:any) => {
            const va = a[k], vb = b[k];
            const na = Number(va), nb = Number(vb);
            const both_num = va !== '' && vb !== '' && va !== null && vb !== null && !isNaN(na) && !isNaN(nb);
            const c = both_num ? (na - nb) : String(va || '').localeCompare(String(vb || ''));
            return (c * d) || (Number(b.id) - Number(a.id));
        });
    }

    sms_sort_arrow(key:string){
        if(this.sms_bulk_sort.key != key) return '';
        return this.sms_bulk_sort.desc ? ' ▾' : ' ▴';
    }

    // ── 成效分析：前端分頁 ──
    sms_pg_reset(){
        const c = this.sms_camp || {};
        const len:any = {bulk:(c.bulk||[]).length, trend:(c.bulk_trend||[]).length, once:(c.once||[]).length, manual:(c.manual_emp||[]).length};
        for(const k of Object.keys(this.sms_pg)){
            this.sms_pg[k] = {...this.sms_pg[k], page:0, total_count: len[k] || 0};
            this.sms_pg_str[k] = {...this.sms_pg[k]};
        }
    }

    sms_pg_cb(key:string, pageobj:page){
        if(JSON.stringify(this.sms_pg[key]) != JSON.stringify(pageobj)){
            this.sms_pg[key] = pageobj;
            this.sms_pg_str[key] = {...pageobj};
        }
    }

    sms_page(key:string, arr:any[]){
        if(!Array.isArray(arr)) return [];
        const p = this.sms_pg[key];
        const from = p.page * p.count;
        return arr.slice(from, from + p.count);
    }

    sms_sum(arr:any[], key:string){
        return (arr || []).reduce((s:number, x:any) => s + Number(x && x[key] || 0), 0);
    }

    // 一次性任務裡「附短網址」的那些：只有它們追蹤得到點開，點開率分母只能用它們
    sms_once_tracked(){
        const once = (this.sms_camp && this.sms_camp.once) || [];
        return once.filter((o:any) => Number(o.has_url) === 1);
    }

    // ── 成效分析：圖表（Highcharts）。每次資料到了重建 options 物件，highcharts-chart 看到新 reference 會重畫 ──
    sms_hc(title:string, categories:string[], series:any[], pct_axis:boolean = false, extra:any = {}){
        const yAxis:any[] = [{title:{text:''}, min:0, allowDecimals:false}];
        if(pct_axis) yAxis.push({title:{text:''}, min:0, opposite:true, labels:{format:'{value}%'}, gridLineWidth:0});
        return {
            chart:{ height:300, zoomType:'x', backgroundColor:'transparent', style:{fontFamily:'inherit'} },
            title:{ text:title, align:'left', style:{fontSize:'15px', fontWeight:'600'} },
            credits:{ enabled:false },
            xAxis:{ categories:categories, labels:{ style:{fontSize:'11px'} } },
            yAxis:yAxis,
            tooltip:{ shared:true },
            legend:{ align:'center', verticalAlign:'bottom', itemStyle:{fontSize:'12px'} },
            plotOptions:{ column:{ borderRadius:2, groupPadding:0.12 }, series:{ marker:{ enabled: categories.length <= 31 } } },
            series:series,
            ...extra,
        };
    }

    sms_build_charts(){
        const c = this.sms_camp;
        this.sms_chart = {trend:null, hour:null, batch:null, expo:null, once:null, manual:null};
        if(!c) return;
        const n = (v:any) => Number(v || 0);

        // 月趨勢：後端新到舊，圖要舊到新
        const tr = [...(c.bulk_trend || [])].reverse();
        if(tr.length){
            this.sms_chart.trend = this.sms_hc('系統群發 月趨勢', tr.map(t => t.ym), [
                {type:'column', name:'發送', data: tr.map(t => n(t.sent)), color:'#9fc5e8'},
                {type:'line', name:'點開率 %', yAxis:1, data: tr.map(t => n(t.click_rate)), color:'#1f6f8b'},
                {type:'line', name:'點後登入率 %', yAxis:1, data: tr.map(t => n(t.login_rate)), color:'#e69138'},
                {type:'line', name:'7 天儲值率 %（歸因）', yAxis:1, data: tr.map(t => n(t.dep7_rate)), color:'#1a7f37'},
                {type:'line', name:'至今完成註冊率 %', yAxis:1, data: tr.map(t => n(t.done_rate)), color:'#8e7cc3', dashStyle:'ShortDash'},
            ], true);
        }

        // 依發送時段：補齊 0~23，沒發的時段發送 0、比率不畫
        const hrs = c.bulk_hour || [];
        if(hrs.length){
            const map:any = {};
            hrs.forEach((h:any) => map[n(h.h)] = h);
            const cats = Array.from({length:24}, (_, i) => i);
            this.sms_chart.hour = this.sms_hc('依發送時段（小時）', cats.map(h => h + '時'), [
                {type:'column', name:'發送', data: cats.map(h => map[h] ? n(map[h].sent) : 0), color:'#9fc5e8'},
                {type:'line', name:'點開率 %', yAxis:1, data: cats.map(h => map[h] ? n(map[h].click_rate) : null), color:'#1f6f8b'},
                {type:'line', name:'登入率 %', yAxis:1, data: cats.map(h => map[h] ? n(map[h].login_rate) : null), color:'#e69138'},
            ], true);
        }

        // 批次比較：區間內有發的，依發送量前 12 批，全部用百分比
        const bs = (c.bulk || []).filter((b:any) => n(b.sent) > 0).slice().sort((a:any, b:any) => n(b.sent) - n(a.sent)).slice(0, 12);
        if(bs.length){
            this.sms_chart.batch = this.sms_hc('批次比較（依發送量前 12，單位 %）', bs.map((b:any) => '#' + b.id + ' ' + String(b.title || '').slice(0, 10)), [
                {type:'column', name:'點開率', data: bs.map((b:any) => n(b.click_rate)), color:'#1f6f8b'},
                {type:'column', name:'1 時內點開占點開', data: bs.map((b:any) => n(b.clk_1h_rate)), color:'#6fa8dc'},
                {type:'column', name:'點後登入率', data: bs.map((b:any) => n(b.login_rate)), color:'#e69138'},
                {type:'column', name:'7 天儲值率（歸因）', data: bs.map((b:any) => n(b.attr7_rate)), color:'#1a7f37'},
                {type:'column', name:'至今完成註冊率', data: bs.map((b:any) => n(b.done_rate)), color:'#8e7cc3'},
            ], false, {yAxis:[{title:{text:'%'}, min:0}], tooltip:{shared:true, valueSuffix:'%'}});
        }

        // 每人收到幾封
        const ex = (c.bulk_total && c.bulk_total.exposure) || [];
        if(ex.length){
            this.sms_chart.expo = this.sms_hc('每人收到幾封（收得越多＝拖越久沒完成註冊）', ex.map((e:any) => e.label), [
                {type:'column', name:'人數', data: ex.map((e:any) => n(e.users)), color:'#9fc5e8', dataLabels:{enabled:true, format:'{point.y:,.0f}'}},
            ], false, {legend:{enabled:false}});
        }

        // 一次性：後端新到舊，取最近 15 個任務、圖要舊到新
        const on = (c.once || []).slice(0, 15).reverse();
        if(on.length){
            // 一次性任務大多沒填標題，用內容開頭當名字
            this.sms_chart.once = this.sms_hc('後台群發簡訊 最近 15 則', on.map((o:any) => '#' + o.id + ' ' + String(o.title || o.content || '').slice(0, 8)), [
                {type:'column', name:'發送', data: on.map((o:any) => n(o.sent)), color:'#9fc5e8'},
                // 沒附短網址的任務追蹤不到點開，畫 null 留空，不要畫成 0
                {type:'column', name:'點開（附短網址才有）', data: on.map((o:any) => Number(o.has_url) === 1 ? n(o.clicked) : null), color:'#1f6f8b'},
                {type:'line', name:'點開率 %', yAxis:1, data: on.map((o:any) => Number(o.has_url) === 1 ? n(o.click_rate) : null), color:'#e69138'},
                {type:'line', name:'7 天儲值率 %', yAxis:1, data: on.map((o:any) => n(o.dep7_rate)), color:'#1a7f37'},
            ], true);
        }

        // 手動：依員工
        const em = c.manual_emp || [];
        if(em.length){
            this.sms_chart.manual = this.sms_hc('後台單人簡訊 依發送員工', em.map((e:any) => e.emp_name || ('#' + e.admin_id)), [
                {type:'column', name:'發送', data: em.map((e:any) => n(e.sent)), color:'#9fc5e8'},
                {type:'column', name:'VIP 追蹤', data: em.map((e:any) => n(e.vip_n)), color:'#8e7cc3'},
                {type:'column', name:'已回歸', data: em.map((e:any) => n(e.vip_back)), color:'#1a7f37'},
                {type:'column', name:'7 天儲值人', data: em.map((e:any) => n(e.dep7_users)), color:'#e69138'},
            ]);
        }
    }

    // 匯出 CSV 給 Excel 研究（前面加 BOM 中文才不會變亂碼）。kind：bulk 批次表 / trend 月趨勢
    sms_export_csv(kind:string){
        if(!this.sms_camp) return;
        let cols:string[][] = [];
        let rows:any[] = [];
        if(kind == 'bulk'){
            cols = [['id','批次'],['kind','類型'],['title','說明'],['schedule','排程／派送時間'],['first_dt','首次派送'],['last_dt','最近派送'],
                    ['push_type','推播條件'],['tags','對象標籤'],['target_user','假扮發送者'],['gift_type','回饋類型'],['gift_num','回饋數'],
                    ['sent','發送'],['users','不重複人'],['clicked','點開'],['click_rate','點開率%'],
                    ['clk_1m','1分內點開'],['clk_1m_rate','1分內點開占點開%'],['clk_1h','1時內點開'],['clk_1h_rate','1時內點開占點開%'],['clk_1d','1天內點開'],['clk_1d_rate','1天內點開占點開%'],
                    ['login','點後登入'],['login_rate','登入率%'],['login_per_click','點開→登入%'],
                    ['recharge_people','點後儲值人(排程)'],['recharge_times','點後儲值次(排程)'],['recharge_twd','點後儲值NT$(排程)'],
                    ['dep7_users','7天儲值人(任一封)'],['dep7_times','7天儲值筆(任一封)'],['dep7_twd','7天儲值NT$(任一封)'],['dep7_rate','7天儲值率%(任一封)'],
                    ['attr7_users','7天儲值人(歸因)'],['attr7_times','7天儲值筆(歸因)'],['attr7_twd','7天儲值NT$(歸因)'],['attr7_rate','7天儲值率%(歸因)'],
                    ['twd_per_sent','每封7天儲值NT$(歸因)'],
                    ['done_reg','至今完成註冊'],['done_rate','至今完成註冊率%'],['deleted','至今已刪除'],['ever_dep_users','至今有儲值人'],['ever_dep_rate','至今有儲值率%'],['ever_dep_twd','至今累計儲值NT$'],
                    ['gift_cost','回饋鑽成本'],
                    ['cum_sent','累計發送'],['cum_clicked','累計點開'],['cum_login','累計登入'],['cum_recharge_people','累計儲值人'],['cum_recharge_twd','累計儲值NT$'],['content','內容']];
            rows = this.sms_camp.bulk || [];
        }else if(kind == 'hour'){
            cols = [['h','時段'],['sent','發送'],['clicked','點開'],['click_rate','點開率%'],['login','點後登入'],['login_rate','登入率%']];
            rows = this.sms_camp.bulk_hour || [];
        }else{
            cols = [['ym','月份'],['sent','發送'],['users','不重複人'],['clicked','點開'],['click_rate','點開率%'],['login','點後登入'],['login_rate','登入率%'],
                    ['recharge_people','點後儲值人(排程)'],['recharge_twd','點後儲值NT$(排程)'],
                    ['dep7_users','7天儲值人(歸因)'],['dep7_times','7天儲值筆(歸因)'],['dep7_twd','7天儲值NT$(歸因)'],['dep7_rate','7天儲值率%(歸因)'],['twd_per_sent','每封7天儲值NT$'],
                    ['done_reg','至今完成註冊'],['done_rate','至今完成註冊率%'],['deleted','至今已刪除'],['ever_dep_users','至今有儲值人'],['ever_dep_rate','至今有儲值率%'],['ever_dep_twd','至今累計儲值NT$']];
            rows = this.sms_camp.bulk_trend || [];
        }
        const esc = (v:any) => {
            const s = (v === null || v === undefined) ? '' : String(v);
            return '"' + s.replace(/"/g, '""') + '"';
        };
        const lines:string[] = [cols.map(c => esc(c[1])).join(',')];
        rows.forEach((r:any) => lines.push(cols.map(c => esc(r[c[0]])).join(',')));
        const blob = new Blob(['﻿' + lines.join('\r\n')], {type:'text/csv;charset=utf-8;'});
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `系統群發簡訊_${kind == 'bulk' ? '批次' : (kind == 'hour' ? '時段' : '月趨勢')}_${new Date().toISOString().slice(0, 10)}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    }

    // 第一次進分頁才給預設區間（最近 30 天）；使用者清空後就尊重他的選擇
    sms_default_range(){
        if(this.sms_start_dt || this.sms_end_dt) return;
        const pad = (n:number) => (n < 10 ? '0' + n : '' + n);
        const ymd = (x:Date) => `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
        const d = new Date();
        this.sms_end_dt = ymd(d);
        d.setDate(d.getDate() - 30);
        this.sms_start_dt = ymd(d);
    }

    sms_pct(a:any, b:any){
        a = Number(a || 0); b = Number(b || 0);
        return b > 0 ? (Math.round(a / b * 1000) / 10) + '%' : '—';
    }

    callback_sms(pageobj:page){
        if(JSON.stringify(this.page_sms)!=JSON.stringify(pageobj)){
            this.page_sms = pageobj;
            this.sms_record_list();
        }
    }

    search_sms_log(){
        this.page_sms.page = 0;
        this.sms_record_list();
    }

    click_bounty(id){

        this.loading = true;
        this.datestatus = false;
        //type = 0 寫入
        const body = {
            type:0,data:id,diamond:this.edit_bounty_data.diamond,bounty_time:this.bounty_time
        };

        this.httpClient.post<any>("/v1/common/bounty_controller.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.edit_bounty_data.diamond = res.bounty_data[0]?.diamond;
                this.abounty_Data = res.bounty_data;
                this.datestatus = true;

            }
        });

    }

    bounty_control(){

        if(this.edit_bounty_data.diamondv == 0 || this.edit_bounty_data.diamond == undefined){
            Swal.fire("懸賞鑽石數不能為0!", "", "error");
            return;
        }

        let bounty_user_id = [];

        //手動選擇用戶
        if(this.user_type == 1){

            bounty_user_id = this.bounty_menu;

        }else{
            bounty_user_id = this.all_data;
        }


        let duplicates = [];

        bounty_user_id.forEach(v => {
            // 檢查當前元素是否存在於user_id數組中
            if (this.bounty_id.includes(v.id)) {
                // 如果存在，將其添加到重複數組中
                duplicates.push(v.name);
            }
        });


        if (duplicates.length > 0) {

            Swal.fire("以下用戶已存在於懸賞列表中:", duplicates.join(", "), "error");

        }else{

            this.loading = true;

            //type = 1 寫入
            const body = {
                type:1,data:bounty_user_id,diamond:this.edit_bounty_data.diamond,bounty_time:this.bounty_time
            };

            this.httpClient.post<any>("/v1/common/bounty_controller.php",body).subscribe(res => {
                this.loading = false;
                if(res.status){
                    Swal.fire("懸賞用戶已設定完成!", "", "success");
                    this.init_list();
                }
            });

            this.modalService.dismissAll();

        }

    }

    handleBountyRangeSelected( value: any ): void {
        let  eventDate = value.event;

        if(this.showDatePickersTatus && this.bounty_time != '{}'){

            this.bounty_time.start = moment(this.abounty_Data[0]?.due_start_date).format('YYYY-MM-DD');
            let dateTimeString = this.bounty_time.start + "T00:00:00.000Z"; // 添加时间部分
            this.bounty_time.start = new Date(dateTimeString);
            this.bounty_time.startDate = moment(this.abounty_Data[0]?.due_start_date).format('YYYY-MM-DD');
            dateTimeString = this.bounty_time.startDate + "T00:00:00.000Z"; // 添加时间部分
            this.bounty_time.startDate = new Date(dateTimeString);
            this.bounty_time.end = moment(this.abounty_Data[0]?.due_end_date).format('YYYY-MM-DD');
            dateTimeString = this.bounty_time.end + "T00:00:00.000Z"; // 添加时间部分
            this.bounty_time.end = new Date(dateTimeString);
            this.bounty_time.endDate = moment(this.abounty_Data[0]?.due_end_date).format('YYYY-MM-DD');
            dateTimeString = this.bounty_time.endDate + "T00:00:00.000Z"; // 添加时间部分
            this.bounty_time.endDate = new Date(dateTimeString);

        }else if(this.showDatePickersTatus){
            this.bounty_time.startDate = moment().subtract(10, 'days');
            this.bounty_time.endDate = moment().subtract(0, 'days');
            this.bounty_time.start = moment(this.bounty_time.startDate);
            this.bounty_time.end = moment(this.bounty_time.endDate);
        }else{
            this.bounty_time.start = '';
            this.bounty_time.end = '';
        }

        if(eventDate.startDate){
            this.bounty_time.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.bounty_time.end =  moment(eventDate.endDate).format('YYYY-MM-DD')
        }

        this.showDatePickersTatus = !this.showDatePickersTatus;

    }




    changeUser(){

        if(this.user_type == 2){
            this.bounty_menuLeng = this.pageobj.total_count;
        }else{
            this.bounty_menuLeng = this.bounty_menu.length - 1;
        }

    }


    changePhoneText() {

        // 1) 先把 phone 統一成字串、去空白
         const phone = (this.changePhone ?? '').toString().trim();

        // 2) 基本檢查：只能數字
        if (!/^\d+$/.test(phone)) {
            alert('電話號碼格式不正確（只能輸入數字）');
            return;
        }

        // 3) 依 country_code 決定長度規則
        let isValid = false;

        if (this.edit_data.country_code == 886) {
            // 台灣：0 開頭 10碼；非 0 開頭 9碼
            if (phone.startsWith('0')) {
                isValid = phone.length === 10;
                if (!isValid) {
                    alert('電話號碼格式不正確：886 且 0 開頭需 10 碼');
                    return;
                }
            } else {
                isValid = phone.length === 9;
                if (!isValid) {
                    alert('電話號碼格式不正確：886 且不含 0 開頭需 9 碼');
                    return;
                }
            }
        } else {
            // 非 886：你原本的規則（至少 9 碼）保留
            isValid = phone.length >= 9;
            if (!isValid) {
                alert('電話號碼格式不正確（至少 9 碼）');
                return;
            }
        }

        // 4) 通過才打 API
        this.loading = true;
        const body = {
            type: 1,
            data: this.edit_data,
            changePhone: phone,
            admin_id: Dep.user.id
        };

        this.httpClient.post<any>('/v1/common/update_user.php', body).subscribe({
            next: (res) => {
                this.loading = false;

                if (res?.status) {
                    if (res.type == 1) {
                      alert('該電話已存在 請重新輸入電話號碼');
                      this.changePhone = '';
                    } else {
                      alert('該用戶電話已更新');
                      this.edit_data.phone_num = phone;
                      this.changePhone = '';
                    }
                } else {
                  alert(res?.message || '更新失敗，請稍後再試');
                }
            },
            error: () => {
                this.loading = false;
                alert('系統錯誤，請稍後再試');
            }
        });
    }


    changeNameText() {
        const name = (this.changeName ?? '').toString().trim();
        if (!name) {
            alert('請輸入暱稱');
            return;
        }
        this.loading = true;
        const body = {
            type: 5,
            data: this.edit_data,
            changeName: name,
            admin_id: Dep.user.id
        };
        // console.log('更新暱稱 body:', body);
        this.httpClient.post<any>('/v1/common/update_user.php', body).subscribe({
            next: (res) => {
                this.loading = false;
                if (res?.status) {
                    alert('該用戶暱稱已更新');
                    this.edit_data.name = name;
                    this.changeName = '';
                } else {
                    alert(res?.message || '更新失敗，請稍後再試');
                }
            },
            error: () => {
                this.loading = false;
                alert('系統錯誤，請稍後再試');
            }
        });
    }

    generateFakeAccounts() {
        if (!this.fakeAccountCount || this.fakeAccountCount < 1) {
            alert('請輸入有效的數量');
            return;
        }
        if (!this.fakeAccountPassword || this.fakeAccountPassword.trim().length !== 6) {
            alert('密碼必須為六位數');
            return;
        }
        this.loading = true;
        const body = {
            count: this.fakeAccountCount,
            password: this.fakeAccountPassword.trim(),
            admin_id: Dep.user.id
        };
        this.httpClient.post<any>('/v1/common/create_fake_account.php', body).subscribe({
            next: (res) => {
                this.loading = false;
                if (res?.status) {
                    const phones = res.data || [];
                    this.fakeAccountResult = phones;
                    alert('成功生成 ' + phones.length + ' 個假帳號');
                    this.fakeAccountCount = 1;
                    this.fakeAccountPassword = '';
                    this.init_list();
                } else {
                    alert(res?.message || '生成失敗，請稍後再試');
                }
            },
            error: () => {
                this.loading = false;
                alert('系統錯誤，請稍後再試');
            }
        });
    }

    showdeType(num){
        if(this.groupTagArr[num] != null){
            this.tool_obj.groupTag  = this.groupTagArr[num];
        }
    }

    clearbtn(item,idx,index){

        this.groupTagArr[idx].splice(index, 1);

        if(this.tool_obj.groupTag.includes(item)){
            const index = this.tool_obj.groupTag.indexOf(item);
            this.ngZone.run(() => {
                this.tool_obj.groupTag.splice(index, 1);
                this.tool_obj.groupTag = [...this.tool_obj.groupTag];
                this.cdr.detectChanges(); // 或者使用 this.cdr.markForCheck();
            });
        }

    }


    showType(num){

        if(this.groupTagArr.length == 0){ //一開始第一個值

                this.groupTagArr[num] = this.tool_obj.groupTag;
        }


        if(num == this.oriNum){

            if(this.tool_obj.groupTag.length <  this.groupTagArr[num].length){

                this.groupTagArr[num] =  this.groupTagArr[num].filter(item => this.tool_obj.groupTag.includes(item));

            }else{

                this.tool_obj.groupTag.forEach(item => {


                    if (!this.groupTagArr[num].includes(item)) {
                        this.groupTagArr[num].push(item);
                    }

                });

            }


        }else{ //新類型第一個值

            this.groupTagArr[num] = this.tool_obj.groupTag;
        }


        this.oriNum = num;
        // this.init_list();

    }

    defaultsort(){
        this.pageobj = {page:0,count:10,total_count:0};

    }

    handlesortdata( value: any ): void {
        this.sort_obj = value;
        // 換排序鍵就回第一頁:留在原頁碼看「另一種排序的第 N 頁」沒有意義,也容易讓人以為排序沒生效
        this.pageobj.page = 0;
        this.init_list();
    }

    handlesortdatadetail( value: any ): void {
        this.sort_obj_detail = value;
        this.get_user_active_chart();
    }

    handlesortdatadetail2( value: any,action ): void {
        this.sort_obj_detail2 = value;
        this.view_user_history(this.detail_user,action);
    }

    searchChartTarget(){
        this.get_profile(this.edit_data);
    }

    handleClick(item: any) {
        // 其他相關的邏輯...
        this.tool_obj.profile_menu = '0';
        // 其他相關的邏輯...
        this.get_profile(item);
    }

    check_all_list(){

        this.data.forEach((item:any) => {
            let itembox = {
              id:item.id, selected: false
            }
            this.top_data.push(itembox);
        });

    }

    set_hot_score(type){

        if(type==1 && this.hot_list.list_str.length == 0){
            Swal.fire("請輸入手機號碼清單", "", "error");
            return;
        }


        let title = '是否確定修改以上手機號碼的熱門度調整為'+this.hot_list.score;
        if(type==0){
            title = '是否確認將所有用戶熱門度歸0';
        }

        Swal.fire({
            title: title,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "確定",
            cancelButtonText: "取消",
          }).then((result) => {
              if (result.isConfirmed) {
                this.loading = true;
                const body = {'validate':4,used_type:type,hot_info:this.hot_list};
                this.httpClient.post<any>("/v1/common/update_user.php",body).subscribe(res => {
                    this.loading = false;
                    if(res.status){
                        alert('success');
                    }else{
                        alert(res.message);
                    }
                });
                console.log(type,this.hot_list.score,this.hot_list.list_str);
              }
          });
          console.log('eror');
    }

    all_list(){

        //帶入allid
        const body = {
            page: this.pageobj.page,
            count:this.pageobj.count,
            tool:this.tool_obj,
            sort_obj:this.sort_obj,
            groupTag:this.groupTagArr,
            now:this.now,
            search_date_user:this.search_date_user,
            Usertime:this.Usertime,
            allid:1
        };

        this.httpClient.post<any>("/v1/common/get_user_list.php",body).subscribe(res => {
            if(res.status){
                this.all_data = res.all_id;
            }
        });


        this.bounty_time = {};
        let select_bounty = [];
        this.bounty_menu = [{id:0,name:'已選擇的懸賞用戶'}];

        this.top_data.forEach(v => {
            if(v.selected == true){
                select_bounty.push(v.id);
            }
        });

        this.data.forEach(v => {
            if (select_bounty.includes(v.id)) {
                let tmpList = {id:v.id,name:v.name}
                this.bounty_menu.push(tmpList);
            }
        });

        this.bounty_menuLeng = this.bounty_menu.length - 1;

        this.modalService.open(this.yourModalContent, { centered: true,size: 'lg' });

    }

    handletopDataout( value: any ): void {
        this.top_data = [];
        this.top_data = value;
    }

    handleRangeUserSelected( value: any ): void {

        let  eventDate = value.event;

        if(this.showDatePickersTatusx){
            this.Usertime.startDate = moment().subtract(7, 'days');
            this.Usertime.endDate = moment().subtract(0, 'days');
            this.Usertime.start = moment(this.Usertime.startDate);
            this.Usertime.end = moment(this.Usertime.endDate);
        }else{
            this.Usertime.start = '';
            this.Usertime.end = '';
        }

        if(eventDate.startDate){
            this.Usertime.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.Usertime.end =  moment(eventDate.endDate).format('YYYY-MM-DD')
        }

        this.showDatePickersTatusx = !this.showDatePickersTatusx;

    }


    lasthandleRangeUserSelected( value: any ): void {

        let  eventDate = value.event;

        if(this.lastshowDatePickersTatusx){
            this.LastUsertime.startDate = moment().subtract(7, 'days');
            this.LastUsertime.endDate = moment().subtract(0, 'days');
            this.LastUsertime.start = moment(this.LastUsertime.startDate);
            this.LastUsertime.end = moment(this.LastUsertime.endDate);
        }else{
            this.LastUsertime.start = '';
            this.LastUsertime.end = '';
        }

        if(eventDate.startDate){
            this.LastUsertime.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.LastUsertime.end =  moment(eventDate.endDate).format('YYYY-MM-DD')
        }

        this.lastshowDatePickersTatusx = !this.lastshowDatePickersTatusx;

    }

    ticket_send(data){

        if(this.ticket_num == 0){
            Swal.fire("請選擇發送張數!", "", "error");
        }else{
            this.loading = true;
            const body = {user_id:data.user_id,ticket_num:this.ticket_num};
            this.httpClient.post<any>("/v1/common/ticket_action.php",body).subscribe(res => {
                this.loading = false;
                if(res.status){
                    Swal.fire("摸彩"+this.ticket_num+"張已發送完成!", "", "success");
                    this.ticket_num = 0
                }
            });

        }

    }


    handleRangeSelected( value: any ): void {
        let  eventDate = (value && value.event) ? value.event : {};

        // 沒有選到日期(按「取消日期」時 app-date 會送 startDate/endDate = null)→ 不套任何時間條件。
        // 舊寫法會依 showDatePickersTatus 的奇偶偷偷套上「近 7 天」的 moment 物件,
        // 使用者以為已經取消時間篩選,動態/出入金列表卻只剩最近 7 天(頁數突然變少)。
        this.time.start = '';
        this.time.end = '';

        if (eventDate.startDate && eventDate.endDate) {
            const startMoment = moment(eventDate.startDate);
            const endMoment = moment(eventDate.endDate);
            const diffInDays = endMoment.diff(startMoment, 'days');

            // ✅ 防呆：最多只能選擇 5 個月（約 155 天）
            if (diffInDays > 155) {
                Swal.fire("選取區間不得超過 5 個月！", "請重新選擇日期範圍", "error");
                return; // ❌ 終止後續流程
            }

            this.time.start = startMoment.format('YYYY-MM-DD');
            this.time.end = endMoment.format('YYYY-MM-DD');
        }

        // 這個旗標與 bounty / errtime 的 handler 共用,這裡照舊翻轉,不改動其他 handler 看到的順序
        this.showDatePickersTatus = !this.showDatePickersTatus;

        // 時間條件變了就回第一頁,否則停在超出新總頁數的頁碼會看到空白列表
        this.pageobj3.page = 0;
        this.get_profile(this.edit_data)
    }

    handleRangeSelected1(value: any): void {
        let eventDate = value.event;

        if (this.showDatePickersTatus) {
            this.errtime.startDate = moment().subtract(7, 'days').utcOffset(8); // 調整為 UTC+8
            this.errtime.endDate = moment().subtract(0, 'days').utcOffset(8);
            this.errtime.start = this.errtime.startDate.clone(); // 保持一致
            this.errtime.end = this.errtime.endDate.clone();
        } else {
            this.errtime.start = '';
            this.errtime.end = '';
        }

        if (eventDate.startDate) {
            this.errtime.start = moment(eventDate.startDate).utcOffset(8).format('YYYY-MM-DD HH:mm:ss'); // 加入 UTC+8 調整
            this.errtime.end = moment(eventDate.endDate).utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
        }

        console.log("調整後的時間: ", this.errtime);
    }

    cp_net_url(type=1) {
       // 创建一个唯一的 ID
        const uniqueId = 'dynamicTextarea';

        // 创建一个新的 textarea 元素并设置其 ID
        const el = document.createElement('textarea');
        el.id = uniqueId;
        el.value = this.web_net_info + "?uid=" + this.edit_data.uid + "&emp=" + Dep.user.id;
        // 设置 textarea 的样式
        el.style.position = 'absolute';
        el.style.left = '-50000px';

        const container = document.getElementById('ggggwp');
        // 将 textarea 元素添加到文档主体
        container.appendChild(el);

        // 选中 textarea 内容并复制
        el.select();
        document.execCommand('copy');
        // 移除 textarea 元素
        container.removeChild(el);
        Swal.fire("已複製可貼給用戶!", "", "success");
    }

    copyToClipboard() {
        const el = document.createElement('textarea');
        el.value = this.edit_data.session_token;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        Swal.fire("token已複製到剪貼簿!", "", "success");
    }

    searchTarget(){
        if(this.target_search !== ''){
            this.target_search = this.target_search.replace(/\s/g, '');
            this.target_search = this.target_search.trim();
            Swal.fire({
                title: "確定要搜尋"+this.target_search+"?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "確定",
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                this.pageobj3.page = 0;
                if (result.isConfirmed) {
                    this.get_profile(this.edit_data)
                    Swal.fire("已搜尋完成!", "", "success");
                }
            });
        }else{
            this.pageobj3.page = 0;
            this.get_profile(this.edit_data)
        }
    }

    toggleItem(item: any) {
        item.active = !item.active;

        // 如果你希望同一时间只展开一个项，取消其他项的激活状态：
        this.items.forEach(i => {
          if (i !== item) {
            i.active = false;
          }
        });
    }


    init_attributes(){
        let tmp_data = {};
        Rtable.structure.type = 'txt';
        tmp_data = {
            name:{name:'姓名',type:'opt'},
            profile_pic:{name:'大頭貼',type:'img',type_cls_dk:'width50px'},
            gender:{name:'性別',type:'opt'},
            os_type:{name:'平台',type:'opt'},
            diamond:{name:'鑽石數',type:'num'},
            create_dt:{name:'註冊日'},
            // pics:{name:'照片集',type:'opt'},
            opt:{name:'操作',type:'opt'},
        }
        this.posts_attributes = Rtable.init(tmp_data);
    }

    ngOnInit(): void {

        //活躍分析用
        // 初始化日期為7天前到今天
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

        const defaultStartDate = sevenDaysAgo.toISOString().split('T')[0];
        const defaultStartMonth = sevenDaysAgo.toISOString().slice(0, 7);

        // 統一設定所有日期變數
        this.initializeDateRanges(defaultStartDate, this.today, defaultStartMonth, this.currentMonth);

        this.serverExcelurl = environment.serverExcelurl;


        //活躍分析用


        console.log('登入者資訊 Dep.user: ' + JSON.stringify(Dep.user));

        if (this.route.snapshot.paramMap.get('id') && this.now != '10') {
            this.tool_obj.search_model = this.route.snapshot.paramMap.get('id');
            this.tool_obj.search_country = '-1';
        }

        this.init_attributes();
        this.init_list();
        this.preurl = environment.serverurl;
        this.urltoken = this.serverExcelurl+"/v1/common/export_excel.php?limit=true&token="+Dep.token+"&time="+Date.now()+'&type=1';
        this.urltokencsv = this.serverExcelurl+"/v1/common/export_csv_excel.php?limit=true&token="+Dep.token+"&time="+Date.now()+'&type=1';
        this.urltabletoken = this.preurl+"/v1/common/export_table.php?limit=true&token="+Dep.token+"&time="+Date.now()+'&type=0';
        this.urlprotoken = this.preurl+"/v1/common/export_profile.php?token="+Dep.token+"&time="+Date.now();
        this.power = Dep.auth.power_id;
        this.user = Dep.user;
        this.checkDeviceType();
        window.addEventListener('resize', this.boundResizeHandler);


        const now = new Date();

        // yyyy-mm-dd
        this.today = now.toISOString().slice(0, 10);

        const oneYearAgoDate = new Date(now);
        oneYearAgoDate.setFullYear(now.getFullYear() - 1);
        this.oneYearAgo = oneYearAgoDate.toISOString().slice(0, 10);

        // yyyy-mm
        this.currentMonth = now.toISOString().slice(0, 7);
        this.oneYearAgoMonth = oneYearAgoDate.toISOString().slice(0, 7);
    }

    // 統一初始化日期區間的函數
    initializeDateRanges(startDate: string, endDate: string, startMonth: string, endMonth: string) {

        // 單組日期
        this.startDate = startDate;
        this.endDate = endDate;
        this.startMonth = startMonth;
        this.endMonth = endMonth;

        // 區間差異 - 第一組
        this.startDate1 = startDate;
        this.endDate1 = endDate;
        this.startMonth1 = startMonth;
        this.endMonth1 = endMonth;

        // 區間差異 - 第二組
        this.startDate2 = startDate;
        this.endDate2 = endDate;
        this.startMonth2 = startMonth;
        this.endMonth2 = endMonth;

        //註冊日
        this.startDatecreate = startDate;
        this.endDatecreate = endDate;

        this.startMonthcreate = startMonth;
        this.endMonthcreate = endMonth;
    }

    handlePushMessageEmtSelected(item){

        this.loading = true;
        const body = {data:this.data,push:item,sql_name:this.sql_name};
        this.httpClient.post<any>("/v1/common/once_push_message.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                Swal.fire({
                    title: '已送出',
                    icon: "success"
                });
            }
        });

    }

    check_it(checked:boolean){
        this.data.forEach((value:any)=>{
            value.checked = checked
        })
    }

    check_validate(type,value){
        let status = true;
        if(type!=1){//驗證
            if(value.toString().length>6){
                alert('驗證碼需6碼');
                status = false;
            }
        }
        if(type==1 || !status){
            this.validate_info.validate = Math.random().toString().slice(-6)
        }
    }

    edit(item:any){
        this.fake_info.id = item.id;
        this.fake_info.uid = item.uid;
        this.tmp_img_b64 = item.profile_pic;
        this.fake_info.name = item.name;
        this.fake_info.introduction = item.introduction;
        this.fake_info.greeting = item.greeting;
        this.fake_info.birthday = item.birthday;
        this.fake_info.hobby_name = item.hobby_name;
        this.now = '4';
    }


    data:any=[];
    edit_data:any=[];
    edit_bounty_data:any=[];
    loading:boolean=true;
    msg :string = '';
    pageobj:page = {page:0,count:10,total_count:0};
    pageobj2:page = {page:0,count:10,total_count:0};
    pageobj3:page = {page:0,count:10,total_count:0};
    pageobj4:page = {page:0,count:10,total_count:0};
    pageobj5:page = {page:0,count:10,total_count:0};
    pageobj6:page = {page:0,count:10,total_count:0};
    pageobj7:page = {page:0,count:10,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
    pageobjstr2:string=JSON.parse(JSON.stringify(this.pageobj2))
    pageobjstr3:string=JSON.parse(JSON.stringify(this.pageobj3))
    pageobjstr4:string=JSON.parse(JSON.stringify(this.pageobj4))
    pageobjstr5:string=JSON.parse(JSON.stringify(this.pageobj5))
    pageobjstr6:string=JSON.parse(JSON.stringify(this.pageobj6))
    pageobjstr7:string=JSON.parse(JSON.stringify(this.pageobj7))

    imgback(b64){
        this.fake_info.pic = b64;
        this.tmp_img_b64 = b64;
    }


    fake_default(){
        this.fake_info = {id:-1,gender:'2',uid:'',pic:'',name:'',introduction:'',greeting:'歡迎找我聊天',birthday:'2003-01-01',hobby_name:''};
        this.tmp_img_b64 = '';
    }

    create(type:number){

        this.loading = true;
        const body = {type:type,info:this.fake_info};
        this.httpClient.post<any>("/v1/common/create_fake_user.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.now = "0";
                this.init_list();
            }else{
                alert(res.msg);
            }
        });

        this.fake_default();
    }

    // Tag數據：目前選的區間有幾天（Usertime.start/end 可能是 'YYYY-MM-DD' 字串或 moment 物件）
    tag_range_days(){
        if(!this.Usertime || !this.Usertime.start || !this.Usertime.end) return 0;
        const s = moment(this.Usertime.start), e = moment(this.Usertime.end);
        if(!s.isValid() || !e.isValid()) return 0;
        return e.diff(s, 'days') + 1;
    }

    // 目前選了哪些 tag（名稱，攤平 groupTagArr）
    tag_selected_names(){
        const names:string[] = [];
        (this.groupTagArr || []).forEach((g:any) => (g || []).forEach((n:any) => { if(n && !names.includes(String(n))) names.push(String(n)); }));
        return names;
    }

    // 預設粒度：≤ 62 天看日，再長看週
    tag_default_gran(){
        return this.tag_range_days() <= this.tag_trend_days_limit ? 'day' : 'week';
    }

    // Tag數據 趨勢：get_tag_trend.php 每個 tag 一條線（排程每天寫好的人數）。任何天數都走這裡，圖／表同一份資料
    // poll=true 是交集還沒算完的續抓：不清畫面、不重設粒度，圖一段一段長出來
    load_tag_trend(poll:boolean = false){
        const names = this.tag_selected_names();
        if(!poll){
            this.tagTrendOptions = null;
            this.tag_month_rows = [];
            this.tag_trend_notes = [];
            this.tag_trend_polling = false;
        }
        const seq = ++this.tag_trend_seq;
        if(!names.length){
            this.tag_trend = null;
            return;
        }
        // 多選：預設「同時符合」（交集，一條線）；使用者切成「各自一條線」才是 each。單選也送 and：選到組合 Tag 後端會展開算交集，建立日之前的歷史也有
        const mode = (names.length > 1 && !this.tag_combine) ? 'each' : 'and';
        if(!poll){
            this.tag_trend_loading = true;
            if(this.tag_view_auto){
                this.tag_gran  = this.tag_default_gran();
                this.tag_yaxis = mode == 'each' && names.length > 1 ? 'pct' : 'count';   // 多條線大小差太多，先看占比
            }
        }
        const s = moment(this.Usertime.start).format('YYYY-MM-DD');
        const e = moment(this.Usertime.end).format('YYYY-MM-DD');
        this.httpClient.post<any>("/v1/common/get_tag_trend.php", {tags: names, start_dt: s, end_dt: e, mode: mode}).subscribe(res => {
            if(seq !== this.tag_trend_seq) return;   // 使用者已經換了條件，這是舊的回應
            this.tag_trend_loading = false;
            if(!res || !res.status){
                this.tag_trend = {error: (res && res.msg) || '讀取失敗'};
                this.tag_trend_polling = false;
                return;
            }
            this.tag_trend = res;
            this.render_tag_trend();
            const pending = res.combo ? Number(res.combo.pending || 0) : 0;
            if(pending > 0){
                this.tag_trend_polling = true;
                // 後端一次最多算 6 秒就回，還有沒算完的就再叫；被別的請求鎖住就等久一點
                setTimeout(() => { if(seq === this.tag_trend_seq) this.load_tag_trend(true); }, res.combo.locked ? 1500 : 400);
            }else{
                this.tag_trend_polling = false;
            }
        }, () => {
            if(seq !== this.tag_trend_seq) return;
            this.tag_trend_loading = false;
            this.tag_trend_polling = false;
            this.tag_trend = {error:'讀取失敗'};
        });
    }

    tag_set_gran(g:string){ this.tag_gran = g; this.tag_view_auto = false; this.render_tag_trend(); }
    tag_set_yaxis(y:string){ this.tag_yaxis = y; this.tag_view_auto = false; this.render_tag_trend(); }
    tag_set_combine(v:boolean){ if(this.tag_combine === v) return; this.tag_combine = v; this.load_tag_trend(); }

    // 只重抓 tag 下拉選單（建了新的組合 Tag 之後要立刻看得到），不動名單與圖。
    // 帶 taglist_only=1 後端在跑名單前就回，不會把「匯出 Excel／推播全選」用的搜尋條件快取洗成空條件
    refresh_taglist(){
        const body = {taglist_only:1};
        this.httpClient.post<any>("/v1/common/get_user_list.php", body).subscribe(res => {
            if(res && res.groupTaglist){
                this.tag_list_type = res.groupTaglist.top;
                this.groupTaglist  = res.groupTaglist.bottom;
                this.taglistLoaded = true;
            }
        }, () => {});
    }

    // 把每日陣列切成桶：day＝每天；week＝週一～週日；month＝日曆月。範圍頭尾切齊（範圍只到 16 號，那個月的桶就到 16 號）
    tag_buckets(gran:string){
        const cats:string[] = (this.tag_trend && this.tag_trend.categories) || [];
        const buckets:any[] = [];
        if(gran == 'day'){
            cats.forEach((d, i) => buckets.push({key:d, label:d, idxs:[i]}));
            return buckets;
        }
        let cur:any = null;
        cats.forEach((d, i) => {
            const m = moment(d);
            const key = gran == 'month' ? m.format('YYYY-MM') : m.clone().startOf('isoWeek').format('YYYY-MM-DD');
            if(!cur || cur.key !== key){ cur = {key:key, label:'', idxs:[]}; buckets.push(cur); }
            cur.idxs.push(i);
        });
        buckets.forEach(b => {
            const first = cats[b.idxs[0]], last = cats[b.idxs[b.idxs.length - 1]];
            if(gran == 'month'){
                const full = moment(first).daysInMonth();
                b.label = moment(first).format('YYYY-MM') + (b.idxs.length < full ? '（至 ' + last.slice(5) + '）' : '');
            }else{
                b.label = first.slice(5) + '～' + last.slice(5);
            }
        });
        return buckets;
    }

    // 桶值＝桶內最後一個有資料的日子（人數是存量，取期末）。回 {v, idx}；整桶都沒資料回 null
    tag_bucket_value(arr:any[], idxs:number[]){
        for(let k = idxs.length - 1; k >= 0; k--){
            const v = arr[idxs[k]];
            if(v !== null && v !== undefined) return {v: Number(v), idx: idxs[k]};
        }
        return null;
    }

    // 值換成畫面要的：人數 or 占全站 %（÷ 那天全站累計註冊人數）
    tag_val_for_axis(v:number, idx:number){
        if(this.tag_yaxis != 'pct') return v;
        const tot:number[] = (this.tag_trend && this.tag_trend.total_users) || [];
        const t = Number(tot[idx] || 0);
        return t > 0 ? Math.round(v / t * 10000) / 100 : null;
    }

    render_tag_trend(){
        const res = this.tag_trend;
        if(!res || !res.status){ this.tagTrendOptions = null; this.tag_month_rows = []; this.tag_trend_notes = []; return; }
        const cats:string[] = res.categories || [];
        const buckets = this.tag_buckets(this.tag_gran);
        const labels  = buckets.map((b:any) => b.label);
        const colors  = ['#1f6f8b','#e69138','#1a7f37','#8e7cc3','#c0504d','#6fa8dc','#a64d79','#38761d','#b45f06','#3d85c6'];
        const series:any[] = [];
        const plotLines:any[] = [];
        // 標記線（建立日／定義變更）的小標籤：貼圖頂、橫的、只放兩三個字（tag 名字很長，直立整條字會蓋住圖）；
        // 只有多條線時才在前面加一小段 tag 名字，靠右邊的往左靠避免被裁掉
        const multi_line = (res.series || []).length > 1;
        const mark_label = (txt:string, bi:number, color:string, name:string) => {
            const nm = String(name || '').replace('（啟用中）', '');
            const head = multi_line ? (nm.length > 6 ? nm.slice(0, 6) + '… ' : nm + ' ') : '';
            const near_end = buckets.length > 1 && bi > buckets.length * 0.75;
            return {text: head + txt, rotation: 0, verticalAlign: 'top', textAlign: near_end ? 'right' : 'left',
                    x: near_end ? -4 : 4, y: 13, style: {fontSize:'10px', color: color}};
        };
        (res.series || []).forEach((s:any, si:number) => {
            const color = colors[si % colors.length];
            const toVal = (arr:any[]) => buckets.map((b:any) => { const r = this.tag_bucket_value(arr || [], b.idxs); return r ? this.tag_val_for_axis(r.v, r.idx) : null; });
            series.push({name: s.name, data: toVal(s.data), color: color});
            if(this.tag_show_active && res.mode != 'and'){
                series.push({name: s.name + '（有效人數）', data: toVal(s.active), color: color, dashStyle:'ShortDash'});
            }
            // 交集：主線是「啟用中」（跟名單總筆數同口徑），勾了才把「全部（含未啟用／停權）」畫成虛線
            if(this.tag_show_active && res.mode == 'and' && res.combo && res.combo.count_basis == 'enabled'){
                series.push({name: String(s.name).replace('（啟用中）', '') + '（全部，含未啟用）', data: toVal(s.all_num), color: color, dashStyle:'ShortDash'});
            }
            // tag 定義被改的那天：畫紅虛線
            (s.def_changes || []).forEach((d:string) => {
                const bi = buckets.findIndex((b:any) => b.idxs.some((i:number) => cats[i] === d));
                if(bi >= 0) plotLines.push({color:'#c00', width:1, dashStyle:'Dash', value: bi, zIndex:5, label: mark_label('定義變更', bi, '#c00', s.name)});
            });
            // tag 建立日落在區間內：畫一條灰虛線，左邊本來就不會有資料。線上不放任何字（圖下方黃底說明已經寫是哪天建立的）
            if(s.created && cats.length && s.created > cats[0] && s.created <= cats[cats.length - 1]){
                const bi = buckets.findIndex((b:any) => b.idxs.some((i:number) => cats[i] === s.created));
                if(bi >= 0) plotLines.push({color:'#ccc', width:1, dashStyle:'ShortDot', value: bi, zIndex:4});
            }
        });
        // 白話說明：哪些 tag 整段沒資料、為什麼
        const notes:string[] = [];
        const today = moment().format('YYYY-MM-DD');
        const combo = res.combo || null;
        const pending = combo ? Number(combo.pending || 0) : 0;
        if(res.mode == 'and' && combo){
            const mem = (combo.members || []).map((m:any) => m.name).join('、');
            if(combo.count_basis == 'enabled'){
                notes.push('這條線＝同時符合 ' + mem + ' 且目前「啟用中」的人數：每天拿這幾個 tag 當天排程算好的名單取交集，再只數 is_enable=1 的帳號。跟下方名單的「總筆數」同一個口徑，今天的點＝總筆數。全部人數（含未啟用／停權）勾「同時畫全部人數」看虛線。');
                if(combo.today_live && (combo.live_tags || []).length){
                    notes.push('今天（' + cats[cats.length - 1].slice(5) + '）那一點是即時值：' + (combo.live_tags || []).join('、') + ' 有「即時條件」，名單會把今天已經回來上線的人當場扣掉，這一點也跟著扣，所以會隨時間往下走；昨天以前的點是排程當天算好的快照，不會變。');
                }
            }else{
                notes.push('這條線＝同時符合 ' + mem + ' 的全部人數（含未啟用／停權），所以會比下方名單的「總筆數」多；主庫加了 tag_combo_daily.active_num 欄之後會改畫「啟用中」、跟總筆數對得上。');
            }
            if(pending > 0){
                const done = (combo.total_days || cats.length) - pending;
                notes.push((combo.locked ? '另一個視窗正在算同一組，等它算完就會出現。' : '') + '交集第一次看要算，還有 ' + pending + ' 天在算（已完成 ' + done + '／' + (combo.total_days || cats.length) + ' 天），圖會一段一段長出來；算過的日子會存起來，下次同一組秒開。');
            }
        }
        (res.series || []).forEach((s:any) => {
            const arr:any[] = s.data || [];
            const has = arr.some((v:any) => v !== null && v !== undefined);
            if(s.created && cats.length && s.created > cats[0]){
                notes.push('「' + s.name + '」' + (res.mode == 'and' ? '裡最晚建立的 tag 是 ' : '是 ') + s.created + ' 建立的，之前不會有資料。');
            }
            if(!has && pending == 0){
                const after = (s.created && cats.length && s.created > cats[0]) ? s.created + ' 之後' : '這段期間';
                const endIsToday = cats.length && cats[cats.length - 1] >= today;
                notes.push('「' + s.name + '」' + after + '每天都還沒有人數。可能是：舊資料的補算工具（backfill_tag_map_count.php）還在跑，跑完重按「確認」就有；'
                         + (endIsToday ? '今天的要等排程（cron_cal_tag）算完才會出現；' : '')
                         + '或那幾天排程沒跑。');
            }
        });
        this.tag_trend_notes = notes;
        const granName:any = {day:'日', week:'週', month:'月'};
        const pct = this.tag_yaxis == 'pct';
        this.tagTrendOptions = {
            chart: {type:'line', height:420, zoomType:'x', backgroundColor:'transparent', style:{fontFamily:'inherit'}},
            title: {text:'Tag 人數趨勢（' + res.range.start + ' ～ ' + res.range.end + '，依' + granName[this.tag_gran] + '）', align:'left', style:{fontSize:'15px', fontWeight:'600'}},
            subtitle: {text:(this.tag_gran == 'day' ? '每天排程算完的名單人數' : '每' + granName[this.tag_gran] + '取該期間最後一天的人數（人數是存量，取期末）') + (pct ? '，÷ 當天全站累計註冊人數' : '') + (this.tag_show_active && res.mode != 'and' ? '；虛線＝有效人數（排除停權／未完成註冊／已刪帳號，只有近期有）' : '') + (res.mode == 'and' && res.combo && res.combo.count_basis == 'enabled' ? '；主線只數啟用中帳號（跟名單總筆數同口徑）' + (this.tag_show_active ? '，虛線＝全部（含未啟用／停權）' : '') : '') + (plotLines.length ? '；紅虛線＝tag 定義被修改' : '') + '；斷掉＝那天排程沒跑或舊資料沒補算', align:'left', style:{fontSize:'12px'}},
            credits: {enabled:false},
            xAxis: {categories: labels, tickInterval: Math.max(1, Math.floor(labels.length / 12)), labels:{style:{fontSize:'11px'}}, plotLines: plotLines},
            // 人數預設不從 0 起：43 萬人的 tag 一天只差幾十人，從 0 畫是一條直線、看不出每天有沒有變；要比「量體」再勾「Y 軸從 0 起」
            yAxis: {title:{text: pct ? '占全站 %' : '人數'}, min: (pct || this.tag_y_zero) ? 0 : null, allowDecimals: pct, labels:{format: pct ? '{value}%' : '{value}'}},
            tooltip: {shared:true, valueSuffix: pct ? '%' : ''},
            legend: {align:'center', verticalAlign:'bottom'},
            plotOptions: {series:{marker:{enabled: labels.length <= 60}, connectNulls:false, lineWidth:2}},
            series: series,
        };
        this.tag_month_rows = this.tag_month_table();
    }

    // 月表：每個 tag × 每個月：期末人數（該月最後一個有資料的日子）、占全站 %、比上月、該月最高／最低。與圖的「月」桶同一個函式算，數字一定對得上
    tag_month_table(){
        const res = this.tag_trend;
        if(!res || !res.status) return [];
        const cats:string[] = res.categories || [];
        const tot:number[]  = res.total_users || [];
        const buckets = this.tag_buckets('month');
        const rows:any[] = [];
        (res.series || []).forEach((s:any) => {
            let prev:number|null = null;
            const arr:any[] = s.data || [];
            buckets.forEach((b:any) => {
                const end  = this.tag_bucket_value(arr, b.idxs);
                const vals = b.idxs.map((i:number) => arr[i]).filter((v:any) => v !== null && v !== undefined).map(Number);
                const row:any = {
                    tag: s.name, month: b.label, days: vals.length,
                    end: end ? end.v : null, end_date: end ? cats[end.idx] : '',
                    pct: (end && Number(tot[end.idx]) > 0) ? Math.round(end.v / Number(tot[end.idx]) * 10000) / 100 : null,
                    max: vals.length ? Math.max(...vals) : null, min: vals.length ? Math.min(...vals) : null,
                    delta: null, delta_pct: null,
                };
                if(end && prev !== null){
                    row.delta = end.v - prev;
                    row.delta_pct = prev > 0 ? Math.round((end.v - prev) / prev * 1000) / 10 : null;
                }
                if(end) prev = end.v;
                rows.push(row);
            });
        });
        return rows;
    }

    // 把目前選的多個 tag 存成一個「組合 Tag」（複合Tag 類別、交集），排程隔天起每天算它，之後選它就有交集的趨勢線
    tag_create_composite(){
        const names = this.tag_selected_names();
        if(names.length < 2){ Swal.fire('至少選兩個 tag 才需要組合', '單一 tag 直接就有趨勢線', 'info'); return; }
        const ids:string[] = [];
        Object.keys(this.groupTaglist || {}).forEach(k => ((this.groupTaglist as any)[k] || []).forEach((t:any) => {
            if(names.includes(String(t.name)) && !ids.includes(String(t.id))) ids.push(String(t.id));
        }));
        if(ids.length != names.length){ Swal.fire('有 tag 對不到 id', names.join('、'), 'error'); return; }
        const cats = this.tag_list_type || [];
        const cat  = cats.find((c:any) => String(c.name).indexOf('複合') === 0) || cats[0];
        if(!cat){ Swal.fire('找不到可以放的類別', '', 'error'); return; }
        const name = names.join('＋');
        // 同名的已經有了就不要再建一個（連點兩次、或別人已經建過），直接提示去選它
        const dup = Object.keys(this.groupTaglist || {}).some(k => ((this.groupTaglist as any)[k] || []).some((t:any) => String(t.name).trim() === name));
        if(dup){ Swal.fire('已經有「' + name + '」了', '直接在 tag 下拉選它就有趨勢線，不用再建。', 'info'); return; }
        Swal.fire({
            title: '存成組合 Tag「' + name + '」？',
            text: '放在「' + String(cat.name).trim() + '」類別，條件關係＝交集（同時符合）。排程每天早上算它的人數，明天起在這裡選它就有趨勢線。',
            icon: 'question', showCancelButton: true, confirmButtonText: '建立', cancelButtonText: '取消',
        }).then((r:any) => {
            if(!r.isConfirmed) return;
            const edit_data = {category:'-2', type:'1', status:1, variable1:0, variable2:0, operation1:'', operation2:'', anotheract:0,
                               tables:'-2', field:-2, sid:String(cat.id), mode:'0', name: name, composition: ids};
            this.loading = true;
            this.httpClient.post<any>("/update_tag_list.php", {edit_data: edit_data, type:0, user:[]}).subscribe(res => {
                this.loading = false;
                if(res && res.status){
                    this.refresh_taglist();   // 下拉立刻看得到新 tag（只看圖的模式不會再打名單 API，得自己抓）
                    Swal.fire('已建立「' + name + '」', '排程明天早上算完就有第一天的人數，之後每天累積；用戶列表選 tag 時已經可以用它篩名單。', 'success');
                }else{
                    Swal.fire('建立失敗', (res && res.message) || '', 'error');
                }
            }, () => { this.loading = false; Swal.fire('建立失敗', '', 'error'); });
        });
    }

    // 月表匯 CSV（Excel 直接開：加 BOM）
    tag_export_csv(){
        const rows = this.tag_month_rows || [];
        if(!rows.length) return;
        const cols = [['tag','Tag'],['month','月份'],['end','期末人數'],['end_date','期末日期'],['pct','占全站%'],['delta','比上月(人)'],['delta_pct','比上月%'],['max','該月最高'],['min','該月最低'],['days','有資料天數']];
        const esc = (v:any) => { const s = (v === null || v === undefined) ? '' : String(v); return '"' + s.replace(/"/g, '""') + '"'; };
        const lines:string[] = [cols.map(c => esc(c[1])).join(',')];
        rows.forEach((r:any) => lines.push(cols.map(c => esc(r[c[0]])).join(',')));
        const blob = new Blob(['﻿' + lines.join('\r\n')], {type:'text/csv;charset=utf-8;'});
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `Tag趨勢_月表_${new Date().toISOString().slice(0, 10)}.csv`;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    }

    sort_fn(key,can_sort=1){
        if(can_sort){
            if(key==this.sort_obj.column){
              this.sort_obj.sort = this.sort_obj.sort == '0'?'1':'0';
            }else{
              this.sort_obj.column = key;
              this.sort_obj.sort = '0';
            }
            this.init_list();
        }
    }

    send_reward(){
        if(this.reward_num>0){
            let target = [];
            this.data.forEach((v)=>{
                if(v.checked){
                    target.push(v.id)
                }
            })
            if(target.length>0){

                const body = {
                    ids:target,
                    diamond:this.reward_num,
                };

                this.httpClient.post<any>("/v1/common/send_diamond_pro.php",body).subscribe(res => {
                    this.loading = false;
                    if(res.status){
                        this.all_check = false;
                        this.check_it(false);
                        this.init_list();
                        alert('贈送成功');
                    }
                    this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
                });

            }else{
                alert('請選擇贈送目標');
            }
        }else{
            alert('鑽石數需大於0');
        }
    }

    get_track_detail(){
        this.loading = true;
        const body = {page: this.pageobj2.page,count:this.pageobj2.count,data:this.edit_data};
        this.httpClient.post<any>("/v1/common/get_vip_track_list.php",body).subscribe(res => {
            this.loading = false;

            if(res.status){
                this.edit_data.track_list = res.data;
                this.pageobj2.total_count = res.total_count
            }else{
                this.edit_data.track_list = [];
                this.pageobj2.total_count = 0
            }

            this.pageobjstr2=JSON.parse(JSON.stringify(this.pageobj2))
        });
    }

    init_list(){

        if(this.now == '10'){
            this.tool_obj={groupTag:[],tag:'-2',search_model:'',search_gender:'-1',vender:'0',search_country:'886',filter_status:'-1',is_enable:'1',filter_money_num:0,filter_num:0,sms_contnt:'',track:'0',profile_menu:'0'};
            // 圖一律走趨勢 API（任何天數都同一個資料來源，日／週／月／月表才對得上）。
            // 名單以前只在 ≤ 62 天列（後端要撈範圍內每一天的名單太重）；2026-09-17 後端改成只撈每個 tag 範圍內最新那列，任何天數都列（名單＝最後一天）
            this.tag_trend_mode = this.tag_range_days() > this.tag_trend_days_limit;
            this.load_tag_trend();
        }


        if(this.tool_obj.filter_status != '-1' && this.tool_obj.filter_num == 0){
            return false;
        }

        this.loading = true;


        const body = {page: this.pageobj.page,count:this.pageobj.count,
            tool:this.tool_obj,
            sort_obj:this.sort_obj,
            groupTag:this.groupTagArr,
            now:this.now,
            search_date_user:this.search_date_user,
            Usertime:this.Usertime,
            LastUsertime:this.LastUsertime,
            skip_taglist:this.taglistLoaded?1:0,
            skip_chart: this.now == '10' ? 1 : 0   // Tag數據 的圖改走 get_tag_trend.php，後端不用再解每天名單畫舊圖
        };

        this.httpClient.post<any>("/v1/common/get_user_list.php",body).subscribe(res => {
            console.log('res.data: ', res.data);
            this.loading = false;
            this.country_list = res.country_list;
            if(res.status){
                this.data = res.data.map(user => ({
                    ...user, // 保留後端原始數據
                    isWithdrawInputVisible: false, // 前端 UI 變數
                    withdrawAmount: 0, // 提領金額變數
                    showMaxWarning: false, // 提領金額變數
                    showMinWarning: false // 提領金額變數
                }));
                this.pageobj.total_count = res.total_count;
                this.uptime = res.tagupdate_dt;
            }else{
                this.pageobj.total_count = 0
                this.data = [];
            }
            this.posts_input = {
                attribute:this.posts_attributes,
                content:this.data,
            }
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))

            if (this.route.snapshot.paramMap.get('act') && this.now != '10') {
                this.tool_obj.profile_menu = '0';
                if (this.route.snapshot.paramMap.get('menu')) {
                    this.tool_obj.profile_menu = this.route.snapshot.paramMap.get('menu');
                }
                this.get_profile(this.data[0]);
            }

            if(res.groupTaglist){
                this.tag_list_type = res.groupTaglist.top;
                this.groupTaglist = res.groupTaglist.bottom;
                this.taglistLoaded = true;
            }

            // now=='10' 的圖已改走 load_tag_trend()（get_tag_trend.php），這裡帶 skip_chart=1 不再回 series，舊的 lineOptions 組裝拿掉

            // groupTaglist

        });

        this.bounty_list();

    }

    cp_item(item){
        const id = item.id;
        this.data.forEach(dataItem => {
            if (dataItem.id !== id && dataItem.memo_edit !== 0) {
                dataItem.memo_edit = 0;
            }
        });
        item.memo_edit=1;this.edit_data=JSON.parse(JSON.stringify(item))
    }

    callbackgrow(pageobj:page){
        if(JSON.stringify(this.pagegrow)!=JSON.stringify(pageobj)){
            this.pagegrow = pageobj;
            this.choose('7');
        }
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    callback2(pageobj:page){
        if(JSON.stringify(this.pageobj2)!=JSON.stringify(pageobj)){
            this.pageobj2 = pageobj;
            this.get_track_detail();
        }
    }

    callback3(pageobj:page){
        if(JSON.stringify(this.pageobj3)!=JSON.stringify(pageobj)){
            this.pageobj3 = pageobj;
            this.get_profile(this.edit_data);
        }
    }

    callback5(pageobj:page){
        if(JSON.stringify(this.pageobj4)!=JSON.stringify(pageobj)){
            this.pageobj4 = pageobj;
            this.get_err_comm(this.temp_err);
        }
    }


    callback4(pageobj:page){
        if(JSON.stringify(this.pagebolur)!=JSON.stringify(pageobj)){
            this.pagebolur = pageobj;
            this.bounty_list();
        }
    }


    callbackListDetail(pageobj:page){
        if(JSON.stringify(this.pageobj6)!=JSON.stringify(pageobj)){
            this.pageobj6 = pageobj;
            this.view_user_history(this.detail_user,1);
        }
    }

    callbackNicknameHistory(pageobj:page){
        if(JSON.stringify(this.pageobj7)!=JSON.stringify(pageobj)){
            this.pageobj7 = pageobj;
            this.loadNicknameHistory();
        }
    }

    callbackList(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.get_user_active_chart();
        }
    }

    callbackListpage(pageobj:page ){
        if(JSON.stringify(this.pagemessage)!=JSON.stringify(pageobj)){
            this.pagemessage = pageobj;
            console.log('pagemessage',this.pagemessage);
            this.get_user_active_chart();
        }
    }

    callbackListpage1(pageobj:page ){
        if(JSON.stringify(this.pagemessage1)!=JSON.stringify(pageobj)){
            this.pagemessage1 = pageobj;
            console.log(112313213123132321321321);
            this.get_user_active_chart();

        }
    }

    callbackListpage2(pageobj:page ){
        if(JSON.stringify(this.pagemessage2)!=JSON.stringify(pageobj)){
            this.pagemessage2 = pageobj;

            console.log('pagemessage2',this.pagemessage2);
            this.get_user_active_chart();
        }
    }

    callbackmessagepage1(pageobj:page ){
        if(JSON.stringify(this.pagegirl_message1)!=JSON.stringify(pageobj)){
            this.pagegirl_message1 = pageobj;
            this.get_user_active_chart();
        }
    }

    callbackmessagepage2(pageobj:page ){
        if(JSON.stringify(this.pagegirl_message2)!=JSON.stringify(pageobj)){
            this.pagegirl_message2 = pageobj;
            this.get_user_active_chart();
        }
    }




    trace_net(){
        this.loading = true;
        const body = {'validate':2,data:this.edit_data};
        this.httpClient.post<any>("/v1/common/update_user.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                alert('success');
            }else{
                alert(res.message);
            }
        });
    }

    upload(event:any){
        let fileList: FileList = event.target.files;
        if(fileList.length > 0) {
            let file: File = fileList[0];
            var reader = new FileReader();
            reader.readAsDataURL(file);//读出 base64
            reader.onloadend = ((e)=>{
                this.tmp_img_b64 = e.target.result;
            });
        }
    }


    run_chart(value:string){
        if(value=="5"){
            this.pieOptions_data.title.text = '用戶手機系統比例圖'
            this.pieOptions_data.series = [this.os_info.data_series];
        }else if(value=='1'){
            this.barOptions.title.text = '年紀性別對照圖'
            this.barOptions.xAxis[0].categories = this.age_info.column
            this.barOptions.series = this.age_info.data_series;
        }else if(value=='2'){
            this.pieOptions.title.text = '男女比例圖'
            this.pieOptions.series = [this.emp_info.data_series];
        }else if(value=="6"){
            this.pieOptions_data.title.text = '儲值方式比例圖'
            this.pieOptions_data.series = [this.deposit_info.data_series];
        }else if(value=='7'){
            this.barOptions2.title.text = '平台成長圖'
            let categories = [];
            let sub_type_name = [];
            if(this.sub_type=='0'){
                sub_type_name = ['Android','iOs','web'];
            }else{
                sub_type_name = ['未完成','男生','女生'];
            }

            let android :{name:string,data:any} =  {
                name: sub_type_name[0],
                data: []
            };

            let ios =  {
                name: sub_type_name[1],
                data: []
            };

            let web =  {
                name: sub_type_name[2],
                data: []
            };

            this.create_dt_info.forEach((v)=>{
                categories.push(v.date)
                android.data.push(v.ck_1*1)
                ios.data.push(v.ck_2*1)
                web.data.push(v.ck_3*1)
            })

            this.updateFlag = true;
            this.barOptions2.xAxis = {categories: categories };
            this.barOptions2.series = [android,ios,web];

            this.barOptions3.title.text = '平台成長圖'
            this.barOptions4.title.text = '平台成長圖'
            this.barOptions5.title.text = '平台成長圖'

            let categories2 = [];
            let categories3 = [];
            let categories4 = [];

            let android2 :{name:string,data:any} =  {
                name: sub_type_name[0],
                data: []
            };

            let ios2 =  {
                name: sub_type_name[1],
                data: []
            };

            let web2 =  {
                name: sub_type_name[2],
                data: []
            };
            let android3 :{name:string,data:any} =  {
                name: sub_type_name[0],
                data: []
            };

            let android4 :{name:string,data:any} =  {
                name: sub_type_name[0],
                data: []
            };

            let ios3 =  {
                name: sub_type_name[1],
                data: []
            };

            let ios4 =  {
                name: sub_type_name[1],
                data: []
            };

            let web3 =  {
                name: sub_type_name[2],
                data: []
            };

            let web4 =  {
                name: sub_type_name[2],
                data: []
            };

            this.create_dt_info2.forEach((v)=>{
                categories2.push(v.date)
                android2.data.push(v.ck_1*1)
                ios2.data.push(v.ck_2*1)
                web2.data.push(v.ck_3*1)
            })

            this.create_dt_info3.forEach((v)=>{
                categories3.push(v.date)
                android3.data.push(v.ck_1*1)
                ios3.data.push(v.ck_2*1)
                web3.data.push(v.ck_3*1)
            })




            this.barOptions3.xAxis = {categories: categories2 };
            this.barOptions3.series = [android2,ios2,web2];
            this.barOptions4.xAxis = {categories: categories3 };
            this.barOptions4.series = [android3,ios3,web3];


            this.chart_satrt = 1;
            this.updateFlag = true;
        }
    }

    savetextarea(){
        Swal.fire({
            title: "確定要儲存內容?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Save",
        }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                this.save();
                Swal.fire("已儲存!", "", "success");
            }
        });
    }

    pagedefaule(){
        this.pageobj3.page = 0;
        this.time.start = '';
        this.time.end = '';
    }


    // ── 用戶標籤 ──
    profileMenuName(){
        // 原本用 profile_menu_list[id] 取名，id 與陣列索引綁死；加了 13 之後改用 find
        const m = this.profile_menu_list.find(x => x.id == this.tool_obj.profile_menu);
        return m ? m.name : '';
    }

    load_user_tags(uid:string, force:boolean = false){
        if(!uid) return;
        // 同一個人：已有資料或正在載入就不重打（換下拉/翻頁/改日期都會再進 get_profile）
        if(!force && this.user_tags_uid === uid && (this.user_tags || this.user_tags_loading)) return;
        if(this.user_tags_uid !== uid){ // 換人：先清掉上一個人的標籤，別讓舊資料閃一下
            this.user_tags = null;
            this.user_tags_history_open = {};
        }
        this.user_tags_uid = uid;
        this.user_tags_loading = true;
        this.httpClient.post<any>("/v1/common/get_user_tags.php", {uid: uid, act: 1}).subscribe(res => {
            if(this.user_tags_uid !== uid) return; // 期間換了人，這包丟掉
            this.user_tags_loading = false;
            this.user_tags = res.status ? this.shape_user_tags(res.data) : null;
        }, _ => {
            if(this.user_tags_uid !== uid) return;
            this.user_tags_loading = false;
            this.user_tags = null;
        });
    }

    phaseLabel(p:string){ return this.tag_phase_label[p] || p; }

    toggleAllGroups(open:boolean){
        if(!this.user_tags || !this.user_tags.groups) return;
        for(const g of this.user_tags.groups) g.open = open;
    }

    // 愛聊對象分頁：全部資料一次拿回來（後端已把用不到的 male_tags/female_tags 拿掉），換頁只切陣列不重打 API。
    // 用 repo 既有的 app-pagnation：data 傳深拷貝物件（換 reference 才會觸發它的 ngOnChanges），page 是 0-based。
    setPairsPage(page:number){
        const u = this.user_tags;
        if(!u || !u.pairs) return;
        const c = Math.max(1, Number(u.pairs_page && u.pairs_page.count) || 25);
        const last = Math.max(0, Math.ceil(u.pairs.length / c) - 1);
        const p = Math.min(Math.max(Number(page) || 0, 0), last);
        u.pairs_page = {page: p, count: c, total_count: u.pairs.length};
        u.pairs_pageview = JSON.parse(JSON.stringify(u.pairs_page));
        u.pairs_view = u.pairs.slice(p * c, p * c + c);
    }

    onPairsPage(pageobj:any){
        this.setPairsPage(pageobj && pageobj.page);
    }

    shape_user_tags(d:any){
        if(!d) return null;
        const out:any = {
            ready: d.ready, profile: d.profile || null, pairs: d.pairs || [], runs: d.runs || [],
            seg_info: d.seg_info || null, cfg: d.cfg || {}, groups: [], brief: [], summary: null, pref: null, pref_keys: [],
            // 最後上線日直接取現在的 user_behavor.last_singin_date（後端每次讀都現查），不是分析當下的快照
            last_singin_date: d.last_singin_date || null, last_singin_days: (d.last_singin_days === 0 || d.last_singin_days) ? d.last_singin_days : null,
            pref_meta: {}, runs_rounds: 0,
            pairs_view: [], pairs_page: {page:0, count:25, total_count:0}, pairs_pageview: null
        };
        // 愛聊對象第一頁（分析 200 位時表格會太長，切成每頁 25 筆）
        out.pairs_page = {page:0, count:25, total_count: out.pairs.length};
        out.pairs_pageview = JSON.parse(JSON.stringify(out.pairs_page));
        out.pairs_view = out.pairs.slice(0, 25);
        if(!out.profile) return out;
        // 這個人被排程處理過幾輪（結果列各代表一輪）。
        // 不在畫面上顯示「這幾筆合計」了：一位 200 對的用戶一輪會寫兩百多列，
        // 表格永遠只看得到一部分，加總出來的數字會比實際少（實測少 11 倍）。累計金額一律用 profile.cost_usd。
        out.runs_rounds = out.runs.filter(r => ['final','partial','skip','error'].indexOf(r.phase) >= 0).length;
        const map:any = {};
        const tags = Array.isArray(out.profile.tags) ? out.profile.tags : [];
        for(const t of tags){
            if(this.tag_key_label[t.key]) t.key = this.tag_key_label[t.key];  // 舊欄位名換成新的顯示名
            if(!map[t.cat]) map[t.cat] = { cat: t.cat, cls: this.tag_cat_cls[t.cat] || 'other', current: [], history: [] };
            t.cls = map[t.cat].cls;   // 樣式與 tooltip 算一次存起來，template 不要每次 change detection 重算
            t.tip = this.tag_tip(t);
            (t.until ? map[t.cat].history : map[t.cat].current).push(t);
        }
        const order = this.tag_cat_order;
        out.groups = Object.keys(map).map(k => map[k]).sort((a, b) => {
            const ia = order.indexOf(a.cat), ib = order.indexOf(b.cat);
            return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
        });
        for(const g of out.groups){
            g.history.sort((a, b) => String(b.until || '').localeCompare(String(a.until || '')));
            // 手風琴：標籤多的分類預設收起來，收起時顯示前幾個值當摘要。
            // 門檻 15：實測「光」的分類是 分群1/作息5/花費10/個人頁14/穩聊對象18/聊天萃取52/關係2，
            // 這個值剛好讓核心資訊（個人頁的年齡星座裝置）維持展開，只收起最長的穩聊對象與聊天萃取
            g.open = g.current.length <= 15;
            g.peek = g.current.slice(0, 5).map(t => t.val).join('、') + (g.current.length > 5 ? ' …' : '');
        }
        // 頂部標籤列：每個分類輪流各取一個，取到 14 個為止。
        // 原本是照分類順序一路塞滿（作息 5 + 花費 9 就滿了），聊天萃取與關係這些最有用的永遠上不了。
        const pickable = out.groups.filter(g => g.cat !== '分群').map(g => g.current.slice());
        for(let round = 0; out.brief.length < 14; round++){
            let added = false;
            for(const list of pickable){
                if(round >= list.length) continue;
                out.brief.push(list[round]); added = true;
                if(out.brief.length >= 14) break;
            }
            if(!added) break;
        }
        out.summary = (out.profile.summary && typeof out.profile.summary === 'object') ? out.profile.summary : null;
        out.pref = (out.profile.partner_pref && typeof out.profile.partner_pref === 'object') ? out.profile.partner_pref : null;
        out.pref_keys = (out.pref && out.pref.pref) ? Object.keys(out.pref.pref) : [];
        out.pref_meta = (out.pref && out.pref.pref_meta) ? out.pref.pref_meta : {};   // 舊資料沒有 meta，template 用 *ngIf 擋掉
        return out;
    }

    requeue_user_tags(deep:boolean = false){
        if(!this.edit_data || !this.edit_data.uid) return;
        const uid = this.edit_data.uid;
        Swal.fire({
            title: deep ? '重新排入並重讀全部對話包？' : '重新排入分析？',
            text: deep ? '愛聊對象的對話會全部重新送模型，成本較高；排程每 5 分鐘處理一人' : '規則標籤重算、愛聊對象只刷新最新一包；排程每 5 分鐘處理一人',
            showCancelButton: true,
            confirmButtonText: '排入',
            cancelButtonText: '取消',
        }).then((r) => {
            if(!r.isConfirmed) return;
            this.httpClient.post<any>("/v1/common/get_user_tags.php", {uid: uid, act: deep ? 3 : 2}).subscribe(res => {
                Swal.fire(res.status ? '已排入' : '失敗', res.message || '', res.status ? 'success' : 'error');
                if(res.status) this.load_user_tags(uid, true);
            }, _ => {
                Swal.fire('失敗', '連線錯誤，請稍後再試', 'error');
            });
        });
    }

    tag_tip(t:any){
        let s = (t.src === 'ai' ? 'AI 萃取' : '規則') + '；自 ' + (t.since || '?');
        if(t.until) s += ' 至 ' + t.until;
        if(t.n > 1) s += '；出現 ' + t.n + ' 次';
        if(t.from) s += '；來源 ' + t.from;
        return s;
    }

    get_profile(item:any){

        console.log("獲取的用戶數據: ", this.edit_data);
        console.log("用戶 is_enable 狀態: ", this.edit_data.is_enable);

        let id = item.uid;
        this.edit_data.memo = item.memo;
        if(this.tool_obj.profile_menu != '13') this.load_user_tags(id); // 標籤列；13 本身的回應就是完整標籤資料
        let itemToMove = this.menu_list.find(item => item.id === '8');

        if(itemToMove == undefined){
            this.menu_list.push({id:'8',name:'用戶履歷'});
            itemToMove = {id:'8',name:'用戶履歷'};
        }

        const index = this.menu_list.findIndex(item => item.id === '8');
        if (index !== -1) {
            this.menu_list.splice(index, 1); // 移除 id 為 8 的項目
        }

        const newIndex = this.menu_list.findIndex(item => item.id === '0') + 1; // 插入位置為 id 為 0 的項目之後
        this.menu_list.splice(newIndex, 0, itemToMove);

        this.now = '8';
        this.loading = true;
        const body = {
            commType: this.commType,
            copy_story_num: this.copy_story_num,
            story_lock: this.story_lock_num,
            story_type: this.story_type_num,
            page: this.pageobj3.page,
            count: this.pageobj3.count,
            uid:id,action: this.tool_obj.profile_menu,
            target_search: this.target_search,
            start_dt: this.time.start,
            end_dt: this.time.end,
            view_story_type:this.view_story_type_num
        };

        this.httpClient.post<any>("/v1/common/get_user_profile.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){

                console.log('res.content_data',res.content_data);
                this.edit_data = res.data;
                console.log('edit_data',this.edit_data);

                this.content_data = res.content_data;
                this.pageobj3.total_count = res.total_count;
                this.packstatus = res.packstatus;

                if(this.tool_obj.profile_menu == '13'){
                    this.user_tags_uid = id;
                    this.user_tags_loading = false;
                    this.user_tags = this.shape_user_tags(res.content_data);
                }

            }else{
                this.pageobj3.total_count = 0;
                // 經紀(power_id=15)開到別家經紀成員的履歷，後端 get_user_profile.php 會回 status=false + 「無權限查看…」。
                // 原本這裡什麼都不做，畫面就停在上一個人的資料，使用者會以為是壞掉；只對「無權限」開頭的訊息跳提示，
                // 其他 status=false（例如後端還沒部署某個 action）維持安靜。
                if(res.msg && String(res.msg).indexOf('無權限') === 0){
                    Swal.fire(res.msg, '', 'warning');
                }
                // 後端還沒部署 action 13 之類：退回輕量 API 拿標籤，面板不會卡在「載入中」
                if(this.tool_obj.profile_menu == '13') this.load_user_tags(id, true);
            }

            this.pageobjstr3=JSON.parse(JSON.stringify(this.pageobj3))

            if(this.tool_obj.profile_menu == 4){
                this.items = [];
                for(let i=0;i < res.content_data.length;i++){
                    res.content_data[i].active = false;
                    this.items[i] = res.content_data[i];
                }
            }

            if(this.tool_obj.profile_menu == 5){
                this.gender = res.data.gender;
                this.areaOptions.title.text = '每月取得';
                this.areaOptions2.title.text = '每月花費';
                this.areaOptions3.title.text = '過去四週取得';
                this.areaOptions4.title.text = '過去四週花費';

                if (Array.isArray(this.areaOptions.yAxis)) {
                    this.areaOptions.yAxis.forEach(yAxis => {
                        yAxis.accessibility = { description: '每月取得鑽石數' };
                    });
                } else {
                    this.areaOptions.yAxis.accessibility = { description: '每月取得鑽石數' };
                }


                if (Array.isArray(this.areaOptions2.yAxis)) {
                    this.areaOptions2.yAxis.forEach(yAxis => {
                        yAxis.accessibility = { description: '每月花費鑽石數' };
                    });
                } else {
                    this.areaOptions2.yAxis.accessibility = { description: '每月花費鑽石數' };
                }

                if (Array.isArray(this.areaOptions3.yAxis)) {
                    this.areaOptions3.yAxis.forEach(yAxis => {
                        yAxis.accessibility = { description: '過去四週取得鑽石數' };
                    });
                } else {
                    this.areaOptions3.yAxis.accessibility = { description: '過去四週取得鑽石數' };
                }

                if (Array.isArray(this.areaOptions4.yAxis)) {
                    this.areaOptions4.yAxis.forEach(yAxis => {
                        yAxis.accessibility = { description: '過去四週花費鑽石數' };
                    });
                } else {
                    this.areaOptions4.yAxis.accessibility = { description: '過去四週花費鑽石數' };
                }

                 //每月取得
                // 使用map方法轉換日期
                let transformedData = res.content_data[0].monthdata.map(item => {
                    let dateStr = item[0];
                    let value = item[1];
                    let timestamp = new Date(dateStr).getTime(); // 將日期轉換為毫秒時間戳
                    return [timestamp, value];
                });

                let monthincome:any= {
                    name: '每月取得鑽石數',
                    data: transformedData,
                    lineColor: Highcharts.getOptions().colors[1],
                    color: Highcharts.getOptions().colors[2],
                    fillOpacity: 0.5,
                    marker: {
                        enabled: false
                    },
                    threshold: null,
                    dataLabels: {
                        enabled: true,  // 啟用數據標籤
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                        },
                    }
                };

                this.areaOptions.series = [monthincome];

                //每月花費
                 // 使用map方法轉換日期
                 let transformedData2 = res.content_data[0].monthconsume.map(item => {
                    let dateStr = item[0];
                    let value = item[1];
                    let timestamp = new Date(dateStr).getTime(); // 將日期轉換為毫秒時間戳
                    return [timestamp, value];
                });

                let monthconsume:any= {
                    name: '每月花費鑽石數',
                    data: transformedData2,
                    lineColor: Highcharts.getOptions().colors[1],
                    color: Highcharts.getOptions().colors[3],
                    fillOpacity: 0.5,
                    marker: {
                        enabled: false
                    },
                    threshold: null,
                    dataLabels: {
                        enabled: true,  // 啟用數據標籤
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                        },
                    }
                };
                this.areaOptions2.series = [monthconsume];

                //過去四周取得
                // 使用map方法轉換日期
                let transformedData3 = res.content_data[0].weekdata.map(item => {
                    let dateStr = item[0];
                    let value = item[1];
                    let timestamp = new Date(dateStr).getTime(); // 將日期轉換為毫秒時間戳
                    return [timestamp, value];
                });

                let weekincome:any= {
                    name: '過去四週取得鑽石數',
                    data: transformedData3,
                    lineColor: Highcharts.getOptions().colors[1],
                    color: Highcharts.getOptions().colors[4],
                    fillOpacity: 0.5,
                    marker: {
                        enabled: false
                    },
                    threshold: null,
                    dataLabels: {
                        enabled: true,  // 啟用數據標籤
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                        },
                    }
                };


                this.areaOptions3.xAxis = {
                    type: 'datetime',
                    labels: {
                        format: '{value:%Y-%m-%d}' // Format the date as "YYYY-MM-DD"
                    },
                    title: {
                        text: '日期'
                    }
                };

                this.areaOptions3.tooltip = {
                    headerFormat: '<strong>Date: {point.key:%Y-%m-%d}</strong><br>',
                    pointFormat: '{point.y}',
                    shared: true
                };

                this.areaOptions3.series = [weekincome];


                 //過去四周花費
                 // 使用map方法轉換日期
                let transformedData4 = res.content_data[0].weekconsume.map(item => {
                    let dateStr = item[0];
                    let value = item[1];
                    let timestamp = new Date(dateStr).getTime(); // 將日期轉換為毫秒時間戳
                    return [timestamp, value];
                });

                let weekincome2:any= {
                    name: '過去四週花費鑽石數',
                    data: transformedData4,
                    lineColor: Highcharts.getOptions().colors[1],
                    color: Highcharts.getOptions().colors[5],
                    fillOpacity: 0.5,
                    marker: {
                        enabled: false
                    },
                    threshold: null,
                    dataLabels: {
                        enabled: true,  // 啟用數據標籤
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                        },
                    }
                };


                this.areaOptions4.xAxis = {
                    type: 'datetime',
                    labels: {
                        format: '{value:%Y-%m-%d}' // Format the date as "YYYY-MM-DD"
                    },
                    title: {
                        text: '日期'
                    }
                };

                this.areaOptions4.tooltip = {
                    headerFormat: '<strong>Date: {point.key:%Y-%m-%d}</strong><br>',
                    pointFormat: '{point.y}',
                    shared: true
                };

                this.areaOptions4.series = [weekincome2];

                this.updateFlag = true;
                let diamondarr = [];
                if(res.content_data[0].monthconsume.length > 0){
                    diamondarr = res.content_data[0].monthconsume;
                }else{
                    diamondarr = res.content_data[0].monthdata;
                }

                this.diamondtotal = diamondarr.reduce((acc, curr) => acc + curr[1], 0);
            }

        });
    }

    // 身分（user.identity）。內部身分（0/2/5/6）在統計、分潤、配對上都會被特別處理，履歷上要一眼看得到。
    identity_map:any = {0:'簽約員工', 1:'一般用戶', 2:'內部員工', 3:'經紀成員', 4:'業配人員', 5:'陪聊', 6:'內部經紀', 7:'外部經紀', 99:'官方帳號'};
    identityName(v:any):string{
        const k = Number(v);
        return this.identity_map[k] !== undefined ? this.identity_map[k] : '未知';
    }

    // 帳號狀態。is_enable：1 正常 / 2 正常(已復權) / 0 停權 / -1 停權且鎖裝置 / -2 未註冊完成；
    // phone_num < 0 是已刪除的帳號（列表那邊也是用這個判斷，見 post.val.phone_num < 0 ? '刪除'）
    userStatusName():string{
        const d:any = this.edit_data || {};
        if(Number(d.phone_num) < 0) return '已刪除';
        switch(Number(d.is_enable)){
            case 1:  return '正常';
            case 2:  return '正常（已復權）';
            case 0:  return '停權';
            case -1: return '停權且鎖裝置';
            case -2: return '未註冊完成';
            default: return '未知（' + d.is_enable + '）';
        }
    }
    userIsBlocked():boolean{
        const d:any = this.edit_data || {};
        return Number(d.phone_num) < 0 || Number(d.is_enable) === 0 || Number(d.is_enable) === -1;
    }

    // 鑽石換算台幣。男女的匯率不同,因為意義就不同:
    //   女生 ÷17 = 這些鑽石「提領」出去值多少台幣
    //   男生 ÷4  = 這些鑽石當初「買進」大約花了多少台幣
    // 男生的 4 是保守取整:2026-09-14 抽 14 位男用戶、552 筆真實儲值紀錄,
    // 每元拿到的鑽石落在 3.5~4.8(中位 4.45);3.5 那幾檔是 iOS 專屬方案(Apple 抽成)。
    // 取 4 會把台幣價值估高約 10%,要更貼近實際就把這個數字改成 4.45。
    diamondRate():number{
        return Number(this.edit_data && this.edit_data.gender) === 1 ? 4 : 17;
    }
    diamondToTwd(v:any):number{
        const n = Number(v);
        return isFinite(n) ? Math.round(n / this.diamondRate()) : 0;
    }

    getEnableDescription(code: number): string {
        const map: { [key: number]: string } = {
          [-99]: '盜圖原因下架',
          [-44]: '模糊圖片格式誤判',
          [-43]: '模糊圖片不存在',
          [-4]: '後台人工刪除',
          [-3]: '限時到期',
          [-2]: '真的已刪除',
          [-1]: '自主刪除',
          [0]: '不可存取',
          [1]: '可存取',
          [2]: '等待模糊(api server排程)',
          [3]: '等待模糊與縮圖(11F處理)',
        };

        return map[code] ?? `未知狀態(${code})`;
    }

    searchTargetUser(){
        this.default_page();
        this.get_user_active_chart();
    }

    /**
     * 當圖片載入失敗時,改用文字頭像
    */
    onImageError(event: any, user: any) {
        // 圖片載入失敗,隱藏圖片
        event.target.style.display = 'none';

        // 或者設定預設圖片
        // event.target.src = 'assets/images/default-avatar.png';
    }

    changedepositFilter(type){
        this.depositFilter = type;
        this.get_user_active_chart();

    }

    searchKeyword(){
        this.default_page();
        this.get_user_active_chart();
    }

    get_user_active_chart(){
        this.loading = true;
        const body = {
            sortDir:this.sortDir,
            pagemessage:this.pagemessage,
            pagemessage1:this.pagemessage1,
            pagemessage2:this.pagemessage2,
            pagegirl_message1:this.pagegirl_message1,
            pagegirl_message2:this.pagegirl_message2,
            depositFilter:this.depositFilter,
            activeTypeTab:this.activeTypeTab,
            activeTab:this.activeTab,
            target_search_user:this.target_search_user,
            sort_obj:this.sort_obj_detail,
            page: this.pageobj.page,
            count:this.pageobj.count,
            selectedList:this.selectedList,
            selectedFilterPlatform:this.selectedFilterPlatform,
            selectedVendor:this.selectedVendor,
            selectedLevel:this.selectedLevel,
            gender:this.selectedGender,
            os_type:this.selectedPlatform,
            timeGranularity:this.timeGranularity,
            startDate:this.startDate,
            endDate:this.endDate,
            startMonth:this.startMonth,
            endMonth:this.endMonth,
            startDate1:this.startDate1,
            endDate1:this.endDate1,
            startMonth1:this.startMonth1,
            endMonth1:this.endMonth1,
            startDate2:this.startDate2,
            endDate2:this.endDate2,
            startMonth2:this.startMonth2,
            endMonth2:this.endMonth2,
            startDatecreate:this.startDatecreate,
            endDatecreate:this.endDatecreate,
            startMonthcreate:this.startMonthcreate,
            endMonthcreate:this.endMonthcreate,
            showRegisterDate:this.showRegisterDate,
        };
        this.httpClient.post<any>("/v1/common/get_user_active_chart.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.list_arr = res.data;
                if(this.activeTypeTab == 'activity'){
                    if(this.activeTab == 'diff'){
                        this.diff_data = res.data;
                        this.summary = res.data[0].summary;
                        this.new_users = res.data[0].new_users;
                        this.lost_users = res.data[0].lost_users;
                        this.cdr.detectChanges();
                        return;
                    }
                    this.pageobj.total_count = res.total;
                    this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));
                    //男生時先撈女生經紀select
                    if(this.selectedGender == 'male'){
                        this.vendorList = res.vendor;
                        this.levelList = res.Level_list;
                    }
                    this.lineOptions2 = JSON.parse(JSON.stringify(chartdata.line));
                    this.lineOptions3 = JSON.parse(JSON.stringify(chartdata.line));
                    this.lineOptions4 = JSON.parse(JSON.stringify(chartdata.line));
                    this.lineOptions5 = JSON.parse(JSON.stringify(chartdata.line));
                    this.lineOptions2.title.text = '在線分鐘數分析圖';
                    this.lineOptions2.xAxis = { categories: res.categories };
                    this.lineOptions2.series = res.series;
                    this.lineOptions2.plotOptions = {
                        line: {
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    return this.y.toLocaleString(); // 加上千分位逗號
                                }
                            }
                        }
                    };

                    this.lineOptions3.title.text = '動態數分析圖';
                    this.lineOptions3.xAxis = { categories: res.categories };
                    this.lineOptions3.series = res.series2;
                    this.lineOptions3.plotOptions = {
                        line: {
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    return this.y.toLocaleString(); // 加上千分位逗號
                                }
                            }
                        }
                    };


                    this.lineOptions4.title.text = '發出/接收 訊息分析圖';
                    this.lineOptions4.xAxis = { categories: res.categories };
                    this.lineOptions4.series = res.series3;
                    this.lineOptions4.plotOptions = {
                        line: {
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    return this.y.toLocaleString(); // 加上千分位逗號
                                }
                            }
                        }
                    };


                    this.lineOptions5.title.text = '語音 /視訊  (分鐘) 分析圖';
                    this.lineOptions5.xAxis = { categories: res.categories };
                    this.lineOptions5.plotOptions = {
                        line: {
                            dataLabels: {
                                enabled: true,
                                formatter: function() {
                                    return this.y.toLocaleString(); // 加上千分位逗號
                                }
                            }
                        }
                    };
                    this.lineOptions5.series = res.series4;
                    this.updateFlag = true;
                    this.cdr.detectChanges();

                }else{

                    if(this.activeTab == 'query'){

                        const data: any = res.data ?? {};
                        this.dataMap = data;
                        if(this.selectedGender == 'male'){
                            if(this.depositFilter == 'unpaid'){
                                this.pagemessage.total_count = data['0-99'].paging.total_count;
                            }else{
                                this.pagemessage.total_count = data['100-5000'].paging.total_count;
                                this.pagemessage1.total_count = data['5001-30000'].paging.total_count;
                                this.pagemessage2.total_count = data['30001+'].paging.total_count;
                                this.pagemessagestr1=JSON.parse(JSON.stringify(this.pagemessage1));
                                this.pagemessagestr2=JSON.parse(JSON.stringify(this.pagemessage2));
                            }

                            this.pagemessagestr=JSON.parse(JSON.stringify(this.pagemessage));

                        }else{
                            this.pagegirl_message1.total_count = data.hasText_total;
                            this.pagegirl_message2.total_count = data.noText_total;
                            this.pagegirl_messagestr1=JSON.parse(JSON.stringify(this.pagegirl_message1));
                            this.pagegirl_messagestr2=JSON.parse(JSON.stringify(this.pagegirl_message2));
                        }


                    }else{
                        this.analysisData = res.data ?? [];

                        if(this.selectedGender == 'male'){


                            const rangeToPager: Record<string, any> = this.depositFilter === 'unpaid'
                                                                        ? { '0-99': this.pagemessage }
                                                                        : {
                                                                            '100-5000': this.pagemessage,
                                                                            '5001-30000': this.pagemessage1,
                                                                            '30001+': this.pagemessage2,
                                                                          };


                            for (const range of this.analysisData || []) {
                                const pager = rangeToPager[range.range_key];
                                if (!pager) continue;
                                pager.total_count = range.count ?? 0;
                            }

                            this.pagemessagestr=JSON.parse(JSON.stringify(this.pagemessage));
                            if(this.depositFilter !== 'unpaid'){
                                this.pagemessagestr1=JSON.parse(JSON.stringify(this.pagemessage1));
                                this.pagemessagestr2=JSON.parse(JSON.stringify(this.pagemessage2));
                            }

                        }else{

                            this.pagegirl_message1.total_count = this.analysisData.summary.has_count;
                            this.pagegirl_message2.total_count = this.analysisData.summary.no_count;
                            this.pagegirl_messagestr1=JSON.parse(JSON.stringify(this.pagegirl_message1));
                            this.pagegirl_messagestr2=JSON.parse(JSON.stringify(this.pagegirl_message2));

                        }
                    }

                }

            }
        });
    }


    trackByFn(index: number, item: any): any {
        // 通用：有唯一值就用(id/user_id/paging_key)，都沒有則回 index(等同無 trackBy，不會壞)
        return item ? (item.id ?? item.user_id ?? item.paging_key ?? index) : index;
    }

    onDateBlur(event: any, type: number) {
        const value = event.target.value; // yyyy-mm-dd
        const suffix = type === 0 ? '' : type.toString();
        if(type == 0){
            this.startDate1 = value;
            this.startDate2 = value;
        }
        this[`startDate${suffix}`] = value;
        this.onFilterChange(); // 手動觸發
    }

    onDateEndBlur(event: any, type: number) {
        const value = event.target.value; // yyyy-mm-dd
        const suffix = type === 0 ? '' : type.toString();
        if(type == 0){
            this.endDate1 = value;
            this.endDate2 = value;
        }
        this[`endDate${suffix}`] = value;
        this.onFilterChange(); // 手動觸發
    }

    choose(value:string){

        this.now = value;
        this.target_search = '';
        if(value == '12'){
            this.get_user_active_chart();
        }else if(value == '11' || value == '13'){

            this.bluer_tcontent = [
                {title:'懸賞人',content:'name',type:2},
                {title:'發起人',content:'ename'},
                {title:'領獎人',content:'usname'},
                {title:'鑽石數',content:'diamond'},
                {title:'狀態',content:'status',type:3},
                {title:'開始時間',content:'due_start_date'},
                {title:'結束時間',content:'due_end_date'},
            ];

            if(value == '13'){
                this.rec_sub = 'sms';
                this.bounty_list();      // 懸賞：分頁狀態沿用 pagebolur（首頁列表的懸賞圖示也靠它）
                this.sms_default_range();
                this.sms_record_list();  // 簡訊紀錄（一次性＋群發＋手動）
            }

        }else if(value !== '8'){

            this.menu_list = this.menu_list.filter(item => item.id !== '8');

            if(value!='4'){
                this.fake_info.id = -1;
            }

            if(value=='0'){
                this.init_list();
                window.location.href = '/admin_rtc/user';
            }else if(value=='10'){
                this.data = [];
                this.pageobj.total_count = 0;
                this.pageobj = {page:0,count:10,total_count:0};
                this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));

                // this.init_list();
            }else{
                this.loading = true;
                const body = {type:value,sub_type:this.sub_type,pagegrow:this.pagegrow};
                this.httpClient.post<any>("/v1/common/get_user_chart.php",body).subscribe(res => {
                    this.loading = false;
                    if(res.status){
                        console.log('res123',res);
                        this.age_info = res.age_data
                        this.emp_info = res.gender_data
                        this.os_info = res.os_type
                        this.deposit_info = res.deposit_info
                        this.create_dt_info = res.create_dt_info
                        this.create_dt_info2 = res.create_dt_info2
                        this.create_dt_info3 = res.create_dt_info3
                        this.create_dt_info4 = res.create_dt_info4
                        this.yearList = res.yearList;
                        if(res.pagegrow){
                            this.pagegrow.total_count = res.pagegrow.total_count;
                            this.pagegrowstr=JSON.parse(JSON.stringify(this.pagegrow));
                        }

                        this.run_chart(value);
                        this.updateFlag = true;
                    }
                    this.now = value;
                });
            }
        }
    }

    save_validate(){
        this.loading = true;
        const body = {'validate':1,data:this.validate_info};
        this.httpClient.post<any>("/v1/common/update_user.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                alert('success');
            }
        });
    }

    sms_go(){
        this.loading = true;
        const body = {validate:3,data:this.edit_data};
        this.httpClient.post<any>("/v1/common/update_user.php",body).subscribe(res => {
            this.loading = false;
            this.init_list();
        });
    }

    get_err_comm(dataitem){
        this.temp_err = dataitem;
        this.err_data = [];
        this.loading = true;
        const body = {data:dataitem,page: this.pageobj4.page,count:this.pageobj4.count};
        this.httpClient.post<any>("/v1/common/get_err_comm.php",body).subscribe(res => {
            this.loading = false;
            this.err_data = res.data;
            this.pageobj4.total_count = res.total_count;
            this.pageobjstr4=JSON.parse(JSON.stringify(this.pageobj4))

        });
    }

    userWithdrawDiamond() {
        if(this.edit_data.withdrawAmount < 51000){
            alert("提領鑽石數必須>51000！")
        }else{
            this.loading = true;
            const body = {
                userId: this.edit_data.id, // 明確變數名稱
                withdrawDiamondCount: this.edit_data.withdrawAmount
            };
            this.httpClient.post<any>("/v1/common/user_withdraw_diamonds.php", body).subscribe(res => {
                this.loading = false;
                console.log("res: " + res);

                if (res.status) { // 假設 API 回應有 status 表示成功
                    this.withdrawSuccess[this.edit_data.id] = true; // 只有該用戶顯示
                    setTimeout(() => {
                        this.withdrawSuccess[this.edit_data.id] = false; // 7秒後隱藏提示
                    }, 7000);
                }
            });
        }
    }

    checkMaxValue() {
        if (this.edit_data.withdrawAmount > this.edit_data.diamond) {
          this.edit_data.withdrawAmount = this.edit_data.diamond; // 限制最大值
          this.edit_data.showMaxWarning = true; // 顯示提示
        } else {
          this.edit_data.showMaxWarning = false; // 隱藏提示
        }
        if (this.edit_data.withdrawAmount < 51000) {
            this.edit_data.withdrawAmount = 51000; // 限制最大值
            this.edit_data.showMinWarning = true; // 顯示提示
        } else {
        this.edit_data.showMinWarning = false; // 隱藏提示
        }
    }

    save(){
        console.log("發送請求前的 edit_data:", this.edit_data);
        if(this.edit_data.is_enable != 1 && this.edit_data.is_enable != 2 &&(this.edit_data.block_reason == undefined || this.edit_data.block_reason == '')){
            alert('停權原因未填');
            this.edit_data.is_enable = 1;
        } else {
            this.loading = true;
            const body = {msg:this.msg, data:this.edit_data};
            this.httpClient.post<any>("/v1/common/update_user.php", body).subscribe(res => {
                this.loading = false;
                //this.init_list();
                document.getElementById("ModalClose")?.click();
            });
        }
    }

    private numberFormatter = new Intl.NumberFormat();

    formatNumber(value: number): string {
        return this.numberFormatter.format(value);
    }

    select_user(item,num){
        this.chartlistdata = item;
        this.chat_obj.me = this.edit_data.uid;
        this.chat_obj.mename = this.edit_data.name;
        this.chat_obj.mepic = this.edit_data.profile_pic;
        this.chat_obj.to = item.user_uid;
        this.chat_page = 1;
        this.chat_total_count = 0;
        this.chat_total_pages = 0;
        this.detail_data = [];
        this.loadChatPage(1);
    }

    loadChatPage(page:number){
        if(this.chat_loading) return;
        if(page < 1) page = 1;
        this.chat_loading = true;
        const body = {
            meuid: this.chat_obj.me,
            uid: this.chat_obj.to,
            page: page,
            count: this.chat_page_size,
        };
        this.httpClient.post<any>("/v1/common/get_user_chat_record_paged.php", body).subscribe(res => {
            this.chat_loading = false;
            if(res.status){
                this.subnow = '3';
                this.chat_page = res.page || page;
                this.chat_total_count = res.total_count || 0;
                this.chat_total_pages = res.total_pages || 0;
                this.detail_data = res.data || [];
                window.setTimeout(()=>{
                    var container = document.getElementById('chatRoom');
                    if(container) container.scrollTop = 0;
                },50);
            }else{
                this.chat_page = page;
                this.chat_total_count = 0;
                this.chat_total_pages = 0;
                this.detail_data = [];
            }
        }, () => {
            this.chat_loading = false;
        });
    }

    gotoChatPage(){
        const v = parseInt(this.chat_page_input as string, 10);
        if(isNaN(v) || v < 1){
            this.chat_page_input = '';
            return;
        }
        const target = Math.min(v, this.chat_total_pages || 1);
        this.chat_page_input = '';
        if(target === this.chat_page) return;
        this.loadChatPage(target);
    }

    getChatPageList():number[]{
        const total = this.chat_total_pages;
        if(total <= 0) return [];
        const cur = this.chat_page;
        const span = 2;
        let start = Math.max(1, cur - span);
        let end = Math.min(total, cur + span);
        if(cur - span < 1) end = Math.min(total, end + (1 - (cur - span)));
        if(cur + span > total) start = Math.max(1, start - ((cur + span) - total));
        const arr:number[] = [];
        for(let i = start; i <= end; i++) arr.push(i);
        return arr;
    }

    onScroll(){
        // 改為分頁按鈕後不再使用滾動載入
    }

    // 鎖定滾輪
    disableScroll() {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    }

    // 解鎖滾輪
    enableScroll() {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
    }

    checkstatus(){
        if(this.overlayFlag == true){
            this.disableScroll();
        }else{
            this.enableScroll();
        }
    }

    ToTradelist(type): void {
        let nownum = '0';

        if(type == 'cart'){
            nownum = '5';
        }else{
            nownum = '8';
        }

        const url = this.router.serializeUrl(
            this.router.createUrlTree(['/admin_rtc/tradelist', { now: nownum, name: this.edit_data.name }])
        );

        window.open(url, '_blank');

    }

    checkDeviceType() {
        if (window.innerWidth > 768) { // 假設768px是切換點
            this.isDesktop = true;
        } else {
            this.isDesktop = false;
        }
    }


}
